
(function () {
  'use strict';

  var VER = document.documentElement.getAttribute('data-ver') || '';
  var A = window.CCNAV_ASSETS || {};
  var ROOT = document.documentElement;
  var FRAMED = false;
  var EXT = '';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(n) { return Number(n || 0).toLocaleString('en-US'); }
  function isPhone() { return ROOT.classList.contains('ccn-phone'); }
  function getJSON(name) {
    return fetch(A[name], { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(name + ' returned ' + r.status);
      return r.json();
    });
  }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  var uidN = 0;
  function uid(p) { uidN += 1; return (p || 'u') + uidN; }
  function svg(paths, size, vb, cls) {
    return '<svg class="' + (cls || 'ico') + '" viewBox="' + (vb || '0 0 24 24') + '" width="' + size + '" height="' + size +
      '" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + paths + '</svg>';
  }

  var I = {
    arrow: '<svg class="i-arrow" viewBox="0 0 16 10" width="14" height="9" aria-hidden="true"><path d="M0 5h14M10 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
    chevR: svg('<path d="M9 5l7 7-7 7"/>', 18),
    chevL: svg('<path d="M15 5l-7 7 7 7"/>', 20),
    close: svg('<path d="M5 5l14 14M19 5 5 19"/>', 22),
    wrench: svg('<path d="M14.7 6.3a4 4 0 0 0-5.3 5.3L3.5 17.5a1.4 1.4 0 0 0 2 2l5.9-5.9a4 4 0 0 0 5.3-5.3l-2.4 2.4-2-.6-.6-2z"/>', 20),
    phone: svg('<path d="M6.6 3.5h3l1.4 4.2-2 1.4a12 12 0 0 0 5.9 5.9l1.4-2 4.2 1.4v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.6 5.7a2 2 0 0 1 2-2.2z"/>', 20),
    quote: svg('<path d="M6 3.5h8l4 4V20.5H6z"/><path d="M14 3.5v4h4M9 12h6M9 15.5h6"/>', 20),
    hash: svg('<path d="M9.5 3.5 7.5 20.5M16.5 3.5l-2 17M4.5 8.5h16M3.5 15.5h16"/>', 22),
    ruler: svg('<rect x="2.5" y="7.5" width="19" height="9" rx="1"/><path d="M6.5 7.5v3M10 7.5v4.5M13.5 7.5v3M17 7.5v4.5"/>', 22),
    camera: svg('<path d="M3.5 8.5a2 2 0 0 1 2-2h2l1.5-2h6l1.5 2h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z"/><circle cx="12" cy="13" r="3.6"/>', 22),
    equip: svg('<path d="M3 4.5h2.6L8 15.5h9.5l2.5-7.5H6.5"/><circle cx="9.5" cy="19.5" r="1.5"/><circle cx="16.5" cy="19.5" r="1.5"/>', 22)
  };
  var GROUP_ICON = {
    warehouse: svg('<path d="M2.5 10 12 4.5l9.5 5.5v10.5h-19z"/><path d="M6.5 20.5v-7h11v7M6.5 16h11M6.5 18.3h11"/>', 22),
    medical: svg('<rect x="3.5" y="3.5" width="17" height="17" rx="2"/><path d="M12 7.5v9M7.5 12h9"/>', 22),
    retail: svg('<path d="M4.5 10v10.5h15V10"/><path d="M3 4h18l-1.4 4.6a2.3 2.3 0 0 1-4.2.4 2.3 2.3 0 0 1-3.4.2 2.3 2.3 0 0 1-3.4-.2 2.3 2.3 0 0 1-4.2-.4z"/><path d="M10 20.5V15h4v5.5"/>', 22),
    office: svg('<path d="M8 3.5h8l-1 7H9z"/><path d="M6 10.5h12M12 10.5v6M6.8 19.5 12 16.5l5.2 3"/><circle cx="6.5" cy="20.5" r="1"/><circle cx="17.5" cy="20.5" r="1"/><circle cx="12" cy="21" r="1"/>', 22)
  };
  
  var WH_ICON = [
    [/shelv/i, '<path d="M11 5v38M37 5v38M11 11h26M11 21h26M11 31h26M11 41h26"/><path d="M17 11v10M23 11v10M29 11v10M17 21v10M23 21v10M29 21v10M17 31v10M23 31v10M29 31v10" stroke-width="1"/>'],
    [/cart|truck/i, '<path d="M13 5v31h21"/><path d="M8 5h5M13 28h17l3 8"/><circle cx="18" cy="40" r="4"/><path d="M13 14l13 3v11"/>'],
    [/dock|moving|dolly/i, '<rect x="6" y="25" width="36" height="6"/><rect x="13" y="9" width="22" height="16"/><path d="M13 15h22M24 9v6"/><circle cx="12" cy="37" r="3.5"/><circle cx="36" cy="37" r="3.5"/><path d="M12 31v2.5M36 31v2.5"/>'],
    [/bin|tote/i, '<path d="M6 13h36v5H6z"/><path d="M8.5 18l2.5 22h26l2.5-22"/><path d="M18 26h12"/>'],
    [/bench/i, '<path d="M4 17h40v5H4z"/><path d="M8 22v20M40 22v20M8 33h32"/><path d="M30 17v-6h8v6M32 11V8h4v3"/>'],
    [/./, '<path d="M8 30c0-10 7-17 16-17s16 7 16 17"/><path d="M4 30h9M35 30h9"/><rect x="6" y="34" width="36" height="6"/><circle cx="12" cy="37" r="1"/><circle cx="36" cy="37" r="1"/>']
  ];
  function whIcon(label) {
    if (window.CCWhIcon) { var b = window.CCWhIcon(label); if (b) return b; }
    for (var i = 0; i < WH_ICON.length; i++) if (WH_ICON[i][0].test(label)) return svg(WH_ICON[i][1], 56, '0 0 48 48', 'ico ico--wh');
    return '';
  }
  
  var BASE = '<path d="M14 41h36v6H14z"/><path d="M19 47l3 11M45 47l-3 11"/><path d="M22 58h20" stroke-dasharray="2 3"/>';
  var MOUNT = {
    plate: '<path d="M9 9.5h46" stroke-width="1"/><path d="M9 7v5M55 7v5" stroke-width="1"/><rect x="9" y="16" width="46" height="38" rx="2"/><circle cx="16" cy="23" r="2.6"/><circle cx="48" cy="23" r="2.6"/><circle cx="16" cy="47" r="2.6"/><circle cx="48" cy="47" r="2.6"/><circle cx="32" cy="35" r="6"/><circle cx="32" cy="35" r="1.6"/>',
    threaded: '<path d="M28.5 5h7v36h-7z"/><path d="M28.5 9l7-2.5M28.5 13l7-2.5M28.5 17l7-2.5M28.5 21l7-2.5M28.5 25l7-2.5M28.5 29l7-2.5" stroke-width="1.1"/><path d="M25 37h14v4H25z"/>' + BASE,
    gripring: '<path d="M28.5 7.5a3.5 3.5 0 0 1 7 0V41h-7z"/><path d="M27.5 15h9v3h-9z"/><path d="M25 37h14v4H25z"/>' + BASE,
    expanding: '<path d="M24 5h16v27H24z"/><path d="M28 5v27M32 5v27M36 5v27" stroke-width="1"/><path d="M26 32h12l-1.5 5h-9z"/><path d="M30 37h4v4h-4z"/>' + BASE,
    kingpin: '<path d="M24 14h16v5H24z"/><path d="M29 19v22M35 19v22" stroke-dasharray="2.5 2.5"/><path d="M30 5h4v9h-4z"/><path d="M26 2.5h12v3H26z"/>' + BASE,
    modular: '<path d="M27 6h10v10H27z"/><path d="M27 11h10" stroke-width="1"/><path d="M29.5 16h5v25h-5z"/><path d="M25 37h14v4H25z"/>' + BASE,
    pipe: '<path d="M28 5h8l1.5 32h-11z"/><path d="M28 10l8.2-2M27.8 15l8.6-2M27.6 20l9-2M27.3 25l9.4-2M27 30l9.8-2" stroke-width="1.1"/><path d="M25 37h14v4H25z"/>' + BASE
  };
  function mountSVG(key) { return MOUNT[key] ? svg(MOUNT[key], 72, '0 0 64 64', 'ico ico--mount') : ''; }

  var D = { nav: null };
  var S = { open: null, openBy: null, view: 'desktop', mode: 'new', drawer: false, replaceDoor: 'part' };
  var readyResolve;
  var ready = new Promise(function (r) { readyResolve = r; });

  var HEADS = {
    'casters/type': 'Caster type', 'casters/size': 'Wheel size', 'casters/load': 'Load per caster',
    'casters/mount': 'Mount', 'casters/material': 'Wheel material', 'casters/specialty': 'Specialty and environment',
    'wheels/material': 'Wheel material', 'wheels/size': 'Wheel size', 'wheels/use': 'Wheel use',
    'brands/series': 'Series', 'brands/brands': 'Brands', 'applications/all': 'Casters by application'
  };
  function plural(n, one, many) { return fmt(n) + ' ' + (n === 1 ? one : many); }
  
  var FRAC_WORD = { '1/2': 'a half', '1/4': 'a quarter', '3/4': 'three quarters' };
  function inchWords(label) {
    var m = String(label).match(/^(\d+)(?:-(\d+\/\d+))?"(.*)$/);
    if (!m) return label;
    return m[1] + (m[2] ? ' and ' + (FRAC_WORD[m[2]] || m[2]) : '') + ' inch' + m[3];
  }
  function lensItems(l) {
    if (l.groups) return l.groups.reduce(function (a, g) { return a.concat(g.items); }, []);
    return l.items || [];
  }
  function displayLabel(b, label) {
    if (b.id === 'casters') return label.replace(/\s+Casters$/i, '');
    if (b.id === 'wheels') return label.replace(/\s+Wheels$/i, '');
    return label;
  }
  function byOrders(items) {
    if (items.length < 3) return false;
    var any = false;
    for (var i = 0; i < items.length; i++) {
      if (items[i].orders) any = true;
      if (i && items[i - 1].orders < items[i].orders) return false;
    }
    return any;
  }
  function dupImages(items) {
    var seen = {}, dup = false;
    items.forEach(function (it) { var k = (it.image || '').split('?')[0]; if (!k) return; if (seen[k]) dup = true; seen[k] = 1; });
    return dup;
  }
  function parseInch(label) {
    var m = String(label).match(/^(\d+)(?:-(\d+)\/(\d+))?"/);
    if (!m) return 0;
    return +m[1] + (m[2] ? +m[2] / +m[3] : 0);
  }
  function bandOf(sub) {
    var nums = (String(sub).match(/[\d,]+/g) || []).map(function (x) { return +x.replace(/,/g, ''); });
    if (/^up to/i.test(sub)) return { lo: 0, hi: nums[0] };
    if (/^over/i.test(sub)) return { lo: nums[0], hi: null };
    return { lo: nums[0] || 0, hi: nums[1] || null };
  }

  function imgTag(src, w, alt, scale) {
    return src ? '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="lazy" decoding="async" width="' + w + '" height="' + w + '"' +
      (scale && scale > 1 ? ' style="--s:' + (+scale).toFixed(2) + '"' : '') + '>' : '';
  }
  function countLine(b, it) {
    if (b.hideCounts) return '';
    var n = it.count != null ? '<span class="meta__n">' + fmt(it.count) + ' products</span>' : '';
    var q = it.quickship ? '<span class="meta__qs">' + fmt(it.quickship) + ' QuickShip</span>' : '';
    return n || q ? '<span class="meta">' + n + q + '</span>' : '';
  }
  function flag(it) { return it.top3 ? '<span class="flag">Most ordered</span>' : ''; }

  function tilesHTML(b, l) {
    var icons = !!l.icons || dupImages(l.items);
    var row = l.items.length <= 4;
    return '<div class="tiles' + (row ? ' tiles--row' : '') + (icons ? ' tiles--icons' : '') + '" data-n="' + l.items.length + '">' +
      l.items.map(function (it) {
        var label = displayLabel(b, it.label);
        return '<a class="tile" href="' + esc(it.url) + '" ' + EXT + '>' + flag(it) +
          '<span class="well">' + (icons ? whIcon(it.label) : imgTag(it.image, 240, '', it.imgScale)) + '</span>' +
          '<span class="tile__b"><span class="tile__t">' + esc(label) + '</span>' +
          (it.sub ? '<span class="tile__s">' + esc(it.sub) + '</span>' : '') + countLine(b, it) + '</span></a>';
      }).join('') + '</div>';
  }

  var ICON_W = 120, ICON_H = 110;

  function sizeIcon(inch, wheelOnly) {
    var C = window.CCSizeIcon;
    if (!inch || typeof C !== 'function') return '<span class="size__mm" aria-hidden="true">mm</span>';
    var k = C.pxPerInch(ICON_H) * Math.sqrt(12 / inch) * (isPhone() ? 1.1 : 1);
    var o = { cls: 'size__ico', label: ' ', k: k, width: ICON_W, height: ICON_H, wheelOnly: !!wheelOnly };
    var full = C(inch, o), top = ICON_H, m, re = /[ML](-?[\d.]+) (-?[\d.]+)|V(-?[\d.]+)/g;
    while ((m = re.exec(full))) top = Math.min(top, parseFloat(m[2] != null ? m[2] : m[3]));
    o.height = Math.min(ICON_H, Math.ceil(ICON_H - top + 3));
    return C(inch, o).replace(/ role="img" aria-label=" "/, ' aria-hidden="true" focusable="false"');
  }
  function sizeXlink(b) {
    var other = null;
    if (b.id === 'casters') other = { bar: 'wheels', text: 'Just the wheel? Wheels by size' };
    if (b.id === 'wheels') other = { bar: 'casters', text: 'Need the whole caster? Casters by size' };
    if (other && !D.nav.bar.some(function (x) { return x.id === other.bar && x.lenses.some(function (y) { return y.id === 'size'; }); })) other = null;
    return other ? '<button type="button" class="xlink" data-open="' + other.bar + '" data-lens="size">' + esc(other.text) + ' ' + I.arrow + '</button>' : '';
  }
  function sizesHTML(b, l) {
    var noun = b.id === 'wheels' ? 'wheels' : 'casters';
    return '<div class="sizes" data-n="' + l.items.length + '">' + l.items.map(function (it) {
      var inch = parseInch(it.label);
      var hasCount = !b.hideCounts && it.count != null;
      return '<a class="ccn-size' + (it.top3 ? ' is-top' : '') + '" href="' + esc(it.url) + '" ' + EXT + ' aria-label="' +
        esc(inchWords(it.label) + ' ' + noun + (hasCount ? ', ' + fmt(it.count) + ' products' : '') + (it.quickship ? ', ' + fmt(it.quickship) + ' QuickShip' : '') + (it.top3 ? ', most ordered' : '')) + '">' +
        '<span class="size__fig">' + sizeIcon(inch, b.id === 'wheels') + '</span>' +
        '<span class="size__l">' + esc(it.label) + '</span>' + (it.top3 ? flag(it) : (l.items.some(function (x) { return x.top3; }) ? '<span class="flag flag--slot" aria-hidden="true">Most ordered</span>' : '')) +
        '<span class="size__m">' + (hasCount ? '<span class="meta__n">' + fmt(it.count) + ' products</span>' : '') +
        (it.quickship ? '<span class="meta__qs">' + fmt(it.quickship) + ' QuickShip</span>' : '<span class="size__none" aria-hidden="true"></span>') + '</span></a>';
    }).join('') + '</div>';
  }

  function loadHTML(b, l) {
    var bands = l.items.map(function (it) { return bandOf(it.sub); });
    var marks = [];
    bands.forEach(function (x) { [x.lo, x.hi].forEach(function (v) { if (v && marks.indexOf(v) < 0) marks.push(v); }); });
    marks.sort(function (a, c) { return a - c; });
    function pos(v) {
      if (v == null) return 100;
      if (!v) return 0;
      var i = marks.indexOf(v);
      return ((i + 1) / (marks.length + 1)) * 100;
    }
    var rows = l.items.map(function (it, i) {
      var x = bands[i], a = pos(x.lo), z = pos(x.hi);
      return '<a class="band band--' + i + '" href="' + esc(it.url) + '" ' + EXT + '>' +
        '<span class="well well--sm">' + imgTag(it.image, 160, '', it.imgScale) + '</span>' +
        '<span class="band__b"><span class="band__top"><b>' + esc(it.label) + '</b>' + countLine(b, it) + '</span>' +
        '<span class="band__sub">' + esc(it.sub) + '</span>' +
        '<span class="meter"><i style="left:' + a.toFixed(2) + '%;width:' + (z - a).toFixed(2) + '%"' + (x.hi == null ? ' class="is-open"' : '') + '></i></span></span></a>';
    }).join('');
    var scale = '<div class="band-scale" aria-hidden="true"><span style="left:0">0</span>' + marks.map(function (v) {
      return '<span style="left:' + pos(v).toFixed(2) + '%">' + fmt(v) + '</span>';
    }).join('') + '<span class="end">lb per caster</span></div>';
    var aside = l.aside ? '<div class="calc"><div><b>' + esc(l.aside.label) + '</b><p>' + esc(l.aside.text) + '</p></div>' +
      (l.aside.link ? '<a class="calc__a" href="' + esc(l.aside.link.url) + '" ' + EXT + '>' + esc(l.aside.link.label) + ' ' + I.arrow + '</a>' : '') + '</div>' : '';
    return '<div class="bands">' + rows + scale + '</div>' + aside;
  }

  function mountsHTML(b, l) {
    return '<div class="mounts">' + l.items.map(function (it) {
      var chips = it.plateSizes && it.plateSizes.length ? '<div class="plates"><span class="plates__l">Plate size</span>' + it.plateSizes.map(function (p) {
        return '<a class="plate" href="' + esc(p.url) + '" ' + EXT + '><span>' + esc(p.label) + '</span>' + (b.hideCounts ? '' : '<em>' + fmt(p.count) + '</em>') + '</a>';
      }).join('') + '</div>' : '';
      return '<div class="mount' + (chips ? ' mount--wide' : '') + '"><a class="mount__a" href="' + esc(it.url) + '" ' + EXT + '>' + flag(it) +
        '<span class="mount__fig">' + mountSVG(it.svg) + '</span><span class="tile__t">' + esc(it.label) + '</span>' + countLine(b, it) + '</a>' + chips + '</div>';
    }).join('') + '</div>';
  }

  function listHTML(b, items, cols) {
    var subs = items.some(function (it) { return it.sub; });
    return '<ul class="list' + (subs ? ' list--subs' : '') + '" style="--cols:' + cols + '">' + items.map(function (it) {
      return '<li><a href="' + esc(it.url) + '" ' + EXT + '><span>' + esc(displayLabel(b, it.label)) + (it.sub ? '<small>' + esc(it.sub) + '</small>' : '') + '</span>' +
        (b.hideCounts || it.count == null ? '' : '<em>' + fmt(it.count) + '</em>') + I.arrow + '</a></li>';
    }).join('') + '</ul>';
  }

  function groupsHTML(b, l) {
    return '<div class="groups">' + l.groups.map(function (g) {
      return '<div class="group"><p class="group__hd">' + (GROUP_ICON[g.icon] || '') + '<span>' + esc(g.label) + '</span></p>' + listHTML(b, g.items, 1) + '</div>';
    }).join('') + '</div>';
  }

  function seriesHTML(b, l) {
    return '<div class="series-grid">' + l.items.map(function (it) {
      var words = it.label.split(' ');
      var brand = words.shift(), name = words.join(' ');
      var r = it.range || {};
      return '<a class="series" href="' + esc(it.url) + '" ' + EXT + (it.ariaNote ? ' aria-label="' + esc(it.label + ', ' + (it.count != null ? fmt(it.count) + ' products' : '') + '. ' + it.ariaNote) + '"' : '') + '>' + flag(it) +
        '<span class="well well--sm">' + imgTag(it.image, 160, '', it.imgScale) + '</span>' +
        '<span class="series__b"><span class="series__brand">' + esc(brand) + '</span><span class="series__name">' + esc(name) + '</span>' +
        (r.load ? '<span class="series__spec">' + esc(r.load) + '</span>' : '') +
        (r.diameter ? '<span class="series__spec">' + esc(r.diameter) + ' wheel</span>' : '') +
        countLine(b, it) + '</span></a>';
    }).join('') + '</div>';
  }

  function brandsHTML(b, l) {
    return '<div class="brands">' + l.items.map(function (it) {
      return '<a class="brand" href="' + esc(it.url) + '" ' + EXT + '><span class="brand__logo">' +
        (it.logo ? '<img src="' + esc(it.logo) + '" alt="' + esc(it.label) + '" loading="lazy" decoding="async" width="240" height="135">' : '<b>' + esc(it.label) + '</b>') +
        '</span><span class="brand__n"><b>' + esc(it.label) + '</b>' + (b.hideCounts || it.count == null ? '' : '<em>' + fmt(it.count) + ' products</em>') + '</span></a>';
    }).join('') + '</div>';
  }

  function lensBody(b, l) {
    switch (l.layout) {
      case 'tiles': return tilesHTML(b, l);
      case 'sizes': return sizesHTML(b, l);
      case 'load': return loadHTML(b, l);
      case 'mounts': return mountsHTML(b, l);
      case 'list': return listHTML(b, l.items, l.items.some(function (it) { return it.sub; }) ? 2 : l.items.length > 8 ? 3 : 2);
      case 'groups': return groupsHTML(b, l);
      case 'series': return seriesHTML(b, l);
      case 'brands': return brandsHTML(b, l);
    }
    return '';
  }
  function lensHead(b, l) {
    var title = HEADS[b.id + '/' + l.id] || (b.lenses.length > 1 ? l.label : b.title);
    var items = lensItems(l);
    var note = '';
    if (typeof l.note === 'string') note = l.note;
    else if ((l.layout === 'tiles' || l.layout === 'series' || l.layout === 'brands') && byOrders(items)) note = 'Most ordered first';
    var right = note ? '<p>' + note + '</p>' : '';
    if (l.layout === 'sizes') right = sizeXlink(b);
    return '<div class="lens__hd"><h3>' + esc(title) + '</h3>' + right + '</div>';
  }

  function helpLine(lead) {
    var h = D.nav.header;
    return '<p class="help">' + esc(lead || 'Not sure?') + ' Call <a href="' + esc(h.phoneHref) + '">' + esc(h.phone) + '</a> or <a href="' +
      esc(h.quoteUrl) + '" ' + EXT + '>send a photo</a>.</p>';
  }
  function bestRows(list, id) {
    return '<ol class="best"' + (id ? ' id="' + id + '"' : '') + '>' + list.map(function (p) {
      return '<li><a class="best__a" href="' + esc(p.url) + '" ' + EXT + '><span class="well well--sm">' + imgTag(p.image, 160) + '</span>' +
        '<span class="best__b">' + (p.key ? '<span class="best__k">' + esc(p.key) + '</span>' : '') + '<span class="best__t">' + esc(p.short || p.title) + '</span>' +
        (p.part ? '<code class="best__p">' + esc(p.part) + '</code>' : '') +
        '<span class="best__m">' + (p.price ? '<b>' + esc(p.price) + '</b>' : '<span class="best__q">Request a quote</span>') + (p.quickship ? '<span class="qs-badge">QuickShip</span>' : '') + '</span></span></a></li>';
    }).join('') + '</ol>';
  }

  var BEST = {};
  function barById(id) { return D.nav.bar.filter(function (x) { return x.id === id; })[0]; }
  function bestFor(b, lensId) {
    if (BEST[b.id] === 'revenue' && b.topRevenue && b.topRevenue.length) return b.topRevenue;
    var l = b.lenses.filter(function (x) { return x.id === lensId; })[0];
    return l && l.bestSellers && l.bestSellers.length ? l.bestSellers : (b.bestSellers || []);
  }
  function salesCaption() {
    var sw = D.nav.salesWindow;
    if (!sw) return '';
    var days = Math.round((Date.parse(sw.to) - Date.parse(sw.from)) / 864e5) + 1;
    return 'Last ' + days + ' days, ' + plural(sw.orders, 'order', 'orders');
  }
  function asideHTML(b) {
    var bs = bestFor(b, b.lenses[0].id);
    var rev = b.topRevenue && b.topRevenue.length;
    var lid = 'best-' + b.id;
    var head = !bs.length ? '' : rev ? '<div class="bestsw" role="tablist" aria-label="Show products by">' +
      '<button type="button" class="bestsw__b" role="tab" id="' + lid + '-t1" data-best="orders" aria-selected="true" aria-controls="' + lid + '">Most ordered</button>' +
      '<button type="button" class="bestsw__b" role="tab" id="' + lid + '-t2" data-best="revenue" aria-selected="false" aria-controls="' + lid + '" tabindex="-1">Highest sales</button></div>' :
      '<p class="ccn-eyebrow">Most ordered</p>';
    var cap = '';  
    var quote = b.hideCounts ? '<a class="ccn-btn btn--ghost btn--sm aside__quote" href="' + esc(D.nav.header.quoteUrl) + '" ' + EXT + '>Request a quote</a>' : '';
    return '<div class="aside" role="group" aria-label="' + esc(b.label) + ' shortcuts">' + head + cap +
      (bs.length ? '<div class="best-box"' + (rev ? ' role="tabpanel" aria-labelledby="' + lid + '-t1"' : '') + ' data-key="' + esc(bs.map(function (x) { return x.url; }).join('|')) + '">' + bestRows(bs, lid) + '</div>' : '') +
      '<div class="aside__foot">' +
      (b.viewAll ? '<a class="viewall" href="' + esc(b.url) + '" ' + EXT + '><span>' + esc(b.viewAll) + '</span>' +
        (!b.hideCounts && b.viewAllCount ? '<em>' + fmt(b.viewAllCount) + '</em>' : '') + I.arrow + '</a>' : '') +
      quote + helpLine() + '</div></div>';
  }
  
  var warmed = {};
  function warmBest(id) {
    var b = id !== 'replace' && barById(id);
    if (!b || warmed[id]) return;
    warmed[id] = 1;
    var lists = [b.topRevenue || []].concat(b.lenses.map(function (l) { return l.bestSellers || []; }));
    lists.forEach(function (list) { list.forEach(function (x) { if (x.image) { var im = new Image(); im.decoding = 'async'; im.src = x.image; } }); });
  }
  function syncBest(p) {
    var box = $('.best-box', p);
    if (!box) return;
    var b = barById(p.getAttribute('data-id'));
    var on = $('.stage > .lens.is-on', p);
    var list = bestFor(b, on ? on.getAttribute('data-lens') : b.lenses[0].id);
    var key = list.map(function (x) { return x.url; }).join('|');
    var mode = BEST[b.id] || 'orders';
    $$('.bestsw__b', p).forEach(function (x) {
      var on = x.getAttribute('data-best') === mode;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
      x.tabIndex = on ? 0 : -1;
      if (on && box.hasAttribute('role')) box.setAttribute('aria-labelledby', x.id);
    });
    if (box.getAttribute('data-key') === key) return;
    box.setAttribute('data-key', key);
    box.innerHTML = bestRows(list, 'best-' + b.id);
  }
  function panelHTML(b) {
    var rail = b.lenses.length > 1;
    var aside = (b.bestSellers && b.bestSellers.length) || b.viewAll;
    var railHTML = rail ? '<div class="rail" role="tablist" aria-orientation="vertical" aria-label="Shop ' + esc(b.label) + ' by">' +
      b.lenses.map(function (l, i) {
        return '<button type="button" class="rail__row' + (i ? '' : ' is-on') + '" role="tab" id="tab-' + b.id + '-' + l.id + '" aria-selected="' + (i ? 'false' : 'true') +
          '" aria-controls="lens-' + b.id + '-' + l.id + '" tabindex="' + (i ? -1 : 0) + '" data-lens="' + l.id + '"><span>' + esc(l.label) + '</span></button>';
      }).join('') + '</div>' : '';
    var lenses = b.lenses.map(function (l, i) {
      return '<section class="lens lens--' + l.layout + (i ? '' : ' is-on') + '" id="lens-' + b.id + '-' + l.id + '" role="' + (rail ? 'tabpanel' : 'region') + '" aria-labelledby="' +
        (rail ? 'tab-' + b.id + '-' + l.id : 'bar-' + b.id) + '" data-lens="' + l.id + '">' + lensHead(b, l) + lensBody(b, l) + '</section>';
    }).join('');
    return '<div class="panel" id="panel-' + b.id + '" data-id="' + b.id + '" hidden>' +
      '<div class="pg' + (rail ? '' : ' no-rail') + (aside ? '' : ' no-aside') + '">' + railHTML + '<div class="stage">' + lenses + '</div>' + (aside ? asideHTML(b) : '') + '</div>' +
      (aside ? '' : '<div class="panel__foot">' + helpLine(b.id === 'applications' ? 'Not sure which caster fits the job?' : 'Not sure?') + '</div>') + '</div>';
  }

  function renderBar() {
    var nav = D.nav;
    $('#bar-list').innerHTML = nav.bar.map(function (b) {
      return '<li class="bar__li"><button type="button" class="bar__btn" id="bar-' + b.id + '" data-id="' + b.id + '" aria-expanded="false" aria-controls="panel-' + b.id + '">' +
        '<span class="bar__full">' + esc(b.label) + '</span>' + (b.labelShort ? '<span class="bar__short">' + esc(b.labelShort) + '</span>' : '') + '</button></li>';
    }).join('');
    var q = nav.quickship, qs = $('#bar-qs');
    qs.href = q.url;
    qs.innerHTML = '<i class="qs__dot" aria-hidden="true"></i><span><b>' + esc(q.label) + '</b><small>' + fmt(q.count) + ' ' + esc(q.noun || 'products') + ' &middot; ' + esc(q.sub) + '</small></span>';
    qs.setAttribute('aria-label', q.label + ', ' + fmt(q.count) + ' ' + (q.noun || 'products') + '. ' + q.sub);
    qs.hidden = false;
  }
  function renderPanels() {
    $('#panels-wrap').innerHTML = D.nav.bar.map(panelHTML).join('') + replacePanelHTML();
  }

  var BAR_STEPS = ['is-short', 'is-tight', 'is-tighter', 'is-tightest'];
  function barFits(bar) {
    var list = $('#bar-list', bar), qs = $('#bar-qs', bar);
    if (list.scrollWidth > list.clientWidth + 0.5) return false;
    var last = list.lastElementChild;
    if (!last || !qs || qs.hidden) return true;
    return last.getBoundingClientRect().right + 8 <= qs.getBoundingClientRect().left;
  }
  function fitBar() {
    var bar = $('#bar');
    if (!bar || isPhone()) return;
    BAR_STEPS.forEach(function (c) { bar.classList.remove(c); });
    for (var i = 0; i < BAR_STEPS.length && !barFits(bar); i++) bar.classList.add(BAR_STEPS[i]);
  }

  function layoutTiles(root) {
    $$('.tiles', root).forEach(function (t) {
      var n = +t.getAttribute('data-n');
      var w = t.clientWidth;
      if (!w) return;
      if (t.classList.contains('tiles--row')) { t.style.setProperty('--cols', n); return; }
      var cmax = Math.max(2, Math.floor((w + 10) / 130));
      var rows = Math.ceil(n / cmax);
      t.style.setProperty('--cols', Math.ceil(n / rows));
    });
  }

  var GROW_MAX = 1.35;
  function growTiles(p) {
    var lenses = $$('.stage > .lens', p);
    lenses.forEach(function (l) { l.style.removeProperty('--g'); l.style.removeProperty('--rowadd'); });
    if (!lenses.length) return;
    var stage = $('.stage', p), rail = $('.rail', p), aside = $('.aside', p);
    var cs = getComputedStyle(stage);
    var pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    var side = Math.max(rail ? rail.getBoundingClientRect().height : 0, aside ? aside.getBoundingClientRect().height : 0);
    function ownH(l) { return l.getBoundingClientRect().height + pad; }
    var hs = lenses.map(function (l) { return Math.max(ownH(l), side); });
    var room = parseFloat(p.style.getPropertyValue('--room')) || 1e9;
    var bw = p.offsetHeight - p.clientHeight;
    var top = Math.min(Math.max.apply(null, hs), room - bw);
    lenses.forEach(function (l, i) {
      var t = $('.tiles', l);
      
      var rowsOf = { '.list--subs': function (x) { return Math.ceil($$('li', x).length / 2); }, '.bands': function (x) { return $$('.band', x).length; },
        '.mounts': function (x) { return Math.ceil($$('.mount', x).length / 4) || 1; },
        '.brands': function (x) { return Math.ceil($$('.brand', x).length / 4) || 1; } };
      if (!t) {
        Object.keys(rowsOf).forEach(function (sel) {
          var box = $(sel, l);
          if (!box) return;
          var slack0 = top - ownH(l);
          if (slack0 < 8) return;
          l.style.setProperty('--rowadd', Math.min(sel === '.mounts' || sel === '.brands' ? 40 : 24, slack0 / rowsOf[sel](box)).toFixed(1) + 'px');
          for (var k = 0; k < 4 && ownH(l) > top + 0.5; k++) {
            l.style.setProperty('--rowadd', Math.max(0, parseFloat(l.style.getPropertyValue('--rowadd')) - (ownH(l) - top) / rowsOf[sel](box) - 0.5).toFixed(1) + 'px');
          }
        });
        return;
      }
      if (t.classList.contains('tiles--icons')) return;
      var slack = top - ownH(l);
      if (slack < 16) return;
      var well = $('.well', t);
      var wh = well ? well.getBoundingClientRect().height : 0;
      if (!wh) return;
      var n = +t.getAttribute('data-n'), cols = +getComputedStyle(t).getPropertyValue('--cols') || n;
      var rows = t.classList.contains('tiles--row') ? 1 : Math.ceil(n / cols);
      
      if (rows === 1 && n >= 6 && !t.classList.contains('tiles--row') && 1 + slack / wh > 2.4) {
        t.style.setProperty('--cols', Math.ceil(n / 2));
        slack = top - ownH(l);
        wh = well.getBoundingClientRect().height;
        rows = 2;
      }
      var g = Math.min(rows === 1 ? 1.6 : GROW_MAX, 1 + slack / (rows * wh));
      l.style.setProperty('--g', g.toFixed(3));
      
      for (var k = 0; k < 6 && ownH(l) > top + 0.5 && g > 1; k++) {
        g = Math.max(1, g - (ownH(l) - top) / (rows * wh) - 0.01);
        l.style.setProperty('--g', g.toFixed(3));
      }
    });
  }
  function layoutPanel(p) {
    if (!p) return;
    var top = $('#navzone').getBoundingClientRect().bottom;
    p.style.setProperty('--room', Math.max(260, window.innerHeight - top - 74) + 'px');
    p.style.height = '';
    
    p.classList.add('is-measuring');
    layoutTiles(p);
    if (!p.closest('.ccn-drawer')) growTiles(p);
    p.classList.remove('is-measuring');
  }

  var openT = 0, closeT = 0;
  var OPEN_DELAY = 180; 
  function barBtn(id) { return id === 'replace' ? $('#replace-btn') : $('#bar-' + id); }
  function openPanel(id, opt) {
    syncCall($('#panels-wrap'));
    opt = opt || {};
    clearTimeout(closeT); clearTimeout(openT);
    var p = $('#panel-' + id);
    if (!p) return;
    closeSearch();
    closeHelp();
    var prev = S.open;
    if (prev && prev !== id) {
      var pp = $('#panel-' + prev);
      pp.classList.remove('is-open'); pp.hidden = true;
      var pb = barBtn(prev); if (pb) pb.setAttribute('aria-expanded', 'false');
    }
    var instant = opt.instant || (prev && prev !== id);
    S.open = id;
    S.openBy = opt.by || (prev ? S.openBy : 'click');
    S.openedAt = performance.now();
    var btn = barBtn(id); if (btn) btn.setAttribute('aria-expanded', 'true');
    if (p.hidden) {
      
      if (!opt.lens) { var first = $('.rail__row', p); if (first) setLens(id, first.getAttribute('data-lens')); }
      p.hidden = false;
      warmBest(id);
      p.classList.toggle('no-anim', !!instant);
      layoutPanel(p);
      if (instant) p.classList.add('is-open');
      else requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('is-open'); }); });
    } else {
      p.classList.add('is-open');
      layoutPanel(p);
    }
    if (opt.lens) setLens(id, opt.lens);
    ROOT.classList.add('has-panel');
    if (opt.focus) {
      var f = $('.rail__row.is-on', p) || $('.lens.is-on a, .lens.is-on button, .lens.is-on input', p);
      if (id === 'replace') f = $('.lens.is-on input', p) || $('.rail__row.is-on', p);
      if (f) f.focus();
    }
  }
  function closePanels(opt) {
    opt = opt || {};
    clearTimeout(openT); clearTimeout(closeT);
    if (!S.open) return;
    var id = S.open, p = $('#panel-' + id), btn = barBtn(id);
    S.open = null; S.openBy = null;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    ROOT.classList.remove('has-panel');
    if (p) {
      p.classList.remove('no-anim');
      p.classList.remove('is-open');
      setTimeout(function () { if (S.open !== id) p.hidden = true; }, 130);
    }
    if (opt.focus && btn) btn.focus();
  }
  function setLens(barId, lensId, focus) {
    var p = $('#panel-' + barId);
    if (!p) return;
    $$('.rail__row', p).forEach(function (r) {
      var on = r.getAttribute('data-lens') === lensId;
      r.classList.toggle('is-on', on);
      r.setAttribute('aria-selected', on ? 'true' : 'false');
      r.tabIndex = on ? 0 : -1;
      if (on && focus) r.focus();
    });
    var cur = $('.stage > .lens.is-on', p);
    if (cur && cur.getAttribute('data-lens') === lensId) return;
    var animate = !p.hidden && p.classList.contains('is-open') && !matchMedia('(prefers-reduced-motion: reduce)').matches;
    var from = animate ? p.getBoundingClientRect().height : 0;
    $$('.stage > .lens', p).forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-lens') === lensId); });
    if (barId === 'replace') S.replaceDoor = lensId;
    syncBest(p);
    if (animate) animateHeight(p, from);
  }
  
  function animateHeight(p, from) {
    clearTimeout(p._hT);
    p.classList.remove('is-sizing');
    p.style.height = '';
    var to = p.getBoundingClientRect().height;
    if (Math.abs(to - from) < 1) return;
    p.style.height = from + 'px';
    p.classList.add('is-sizing');
    void p.offsetHeight;
    p.style.height = to + 'px';
    p._hT = setTimeout(function () { p.classList.remove('is-sizing'); p.style.height = ''; }, 170);
  }

  var mouse = [];
  function trackMouse(e) { mouse.push({ x: e.clientX, y: e.clientY, t: performance.now() }); if (mouse.length > 6) mouse.shift(); }

  function headingDown(e) {
    var now = performance.now(), prev = null;
    for (var i = 0; i < mouse.length; i++) if (now - mouse[i].t < 120) { prev = mouse[i]; break; }  
    if (!prev) return false;
    return e.clientY - prev.y > 0.3;             
  }
  function focusables(root) {
    return $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', root).filter(function (el) {
      if (el.tabIndex < 0) return false;
      var lens = el.closest('.lens');
      if (lens && !lens.classList.contains('is-on')) return false;
      return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function enterPanel(id) {
    var p = $('#panel-' + id);
    if (!p) return false;
    var f = id === 'replace' ? ($('.lens.is-on input', p) || $('.rail__row.is-on', p)) : ($('.rail__row.is-on', p) || focusables(p)[0]);
    if (f) { f.focus(); return true; }
    return false;
  }
  function aimingAtStage(rail) {
    var stage = rail.parentNode.querySelector('.stage');
    if (!stage || mouse.length < 2) return false;
    var r = stage.getBoundingClientRect();
    var cur = mouse[mouse.length - 1], prev = mouse[0];
    var up = { x: r.left, y: r.top - 60 }, down = { x: r.left, y: r.bottom + 60 };
    function slope(a, c) { return (c.y - a.y) / ((c.x - a.x) || 0.0001); }
    if (cur.x >= r.left) return false;
    return slope(cur, up) < slope(prev, up) && slope(cur, down) > slope(prev, down);
  }
  var railT = 0;
  function bindPanels() {
    var zone = $('#navzone'), bar = $('#bar');
    $$('.bar__btn', bar).forEach(function (btn) {
      var id = btn.getAttribute('data-id');

      btn.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || S.mode !== 'new') return;
        clearTimeout(closeT);
        if (S.open === 'replace') return; 
        if (S.open && S.open !== id) {
          if (S.openBy === 'click') return;            
          clearTimeout(openT);
          if (headingDown(e)) {
            openT = setTimeout(function () { if (btn.matches(':hover') && S.open && S.open !== id) openPanel(id, { instant: true, by: 'hover' }); }, 220);
          } else {
            openPanel(id, { instant: true, by: 'hover' });
          }
          return;
        }
        if (!S.open) { clearTimeout(openT); openT = setTimeout(function () { openPanel(id, { by: 'hover' }); }, OPEN_DELAY); }
      });
      btn.addEventListener('pointerleave', function () { clearTimeout(openT); });
      btn.addEventListener('click', function () {
        var fresh = S.openedAt && performance.now() - S.openedAt < 400 && S.openBy === 'hover';
        if (S.open === id && S.openBy === 'click' && !fresh) { closePanels(); return; }
        openPanel(id, { by: 'click' });
      });
      btn.addEventListener('keydown', function (e) {
        var all = $$('.bar__btn', bar), i = all.indexOf(btn);
        if (e.key === 'Tab' && !e.shiftKey && S.open === id) {
          
          if (enterPanel(id)) e.preventDefault();
          return;
        }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = all[(i + (e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length];
          n.focus();
          if (S.open && S.open !== 'replace') openPanel(n.getAttribute('data-id'), { instant: true, by: 'click' });
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          openPanel(id, { by: 'click', focus: true });
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          closePanels();
        } else if (e.key === 'Escape') {
          closePanels({ focus: true });
        }
      });
    });
    zone.addEventListener('mouseleave', function () {
      clearTimeout(openT);
      if (S.open && S.openBy === 'hover') closeT = setTimeout(closePanels, 280);
    });
    zone.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    document.addEventListener('mousemove', trackMouse, true);

    var wrap = $('#panels-wrap');
    wrap.addEventListener('mouseover', function (e) {
      var row = e.target.closest('.rail__row');
      if (!row || row.classList.contains('is-on')) return;
      var p = row.closest('.panel'), rail = row.parentNode;
      clearTimeout(railT);
      var go = function () { setLens(p.getAttribute('data-id'), row.getAttribute('data-lens')); };
      if (aimingAtStage(rail)) {
        railT = setTimeout(function () { if (row.matches(':hover')) go(); }, 160);
      } else go();
    });
    wrap.addEventListener('click', function (e) {
      var row = e.target.closest('.rail__row');
      if (row) { setLens(row.closest('.panel').getAttribute('data-id'), row.getAttribute('data-lens')); return; }
      var sw = e.target.closest('.bestsw__b');
      if (sw) {
        var sp = sw.closest('.panel'), from = sp.getBoundingClientRect().height;
        BEST[sp.getAttribute('data-id')] = sw.getAttribute('data-best');
        syncBest(sp);
        animateHeight(sp, from);
        return;
      }
      var x = e.target.closest('.xlink[data-open]');
      if (x) { openPanel(x.getAttribute('data-open'), { lens: x.getAttribute('data-lens'), instant: true, by: S.openBy || 'click' }); }
    });
    wrap.addEventListener('keydown', function (e) {
      var p = e.target.closest('.panel');
      if (!p) return;
      var id = p.getAttribute('data-id');
      if (e.key === 'Escape') { e.preventDefault(); closePanels({ focus: true }); return; }
      var row = e.target.closest('.rail__row');
      if (row) {
        var rows = $$('.rail__row', p), i = rows.indexOf(row), n = null;
        if (e.key === 'ArrowDown') n = rows[(i + 1) % rows.length];
        if (e.key === 'ArrowUp') n = rows[(i + rows.length - 1) % rows.length];
        if (e.key === 'Home') n = rows[0];
        if (e.key === 'End') n = rows[rows.length - 1];
        if (n) { e.preventDefault(); setLens(id, n.getAttribute('data-lens'), true); return; }
        if (e.key === 'ArrowRight') {
          var f = $('.lens.is-on > :not(.lens__hd) a, .lens.is-on > :not(.lens__hd) button:not([disabled]), .lens.is-on > :not(.lens__hd) input', p);
          if (f) { e.preventDefault(); f.focus(); }
        }
      } else if (e.key === 'ArrowLeft' && e.target.closest('.stage') && e.target.tagName !== 'INPUT') {
        var on = $('.rail__row.is-on', p);
        if (on) { e.preventDefault(); on.focus(); }
        return;
      }
      if (e.key === 'Tab') {
        var fs = focusables(p);
        if (!fs.length) return;
        if (e.shiftKey && e.target === fs[0]) {
          e.preventDefault();
          var ob = barBtn(id); if (ob) ob.focus();
        } else if (!e.shiftKey && e.target === fs[fs.length - 1]) {
          e.preventDefault();
          if (id === 'replace') {
            var after = focusables($('#header')), rb = $('#replace-btn'), k = after.indexOf(rb);
            closePanels();
            if (after[k + 1]) after[k + 1].focus();
          } else {
            var bs = $$('.bar__btn', $('#bar')), nb = bs[bs.indexOf(barBtn(id)) + 1] || $('#bar-qs');
            closePanels();
            if (nb) nb.focus();
          }
        }
      }
    });
    zone.addEventListener('focusout', function (e) {
      if (!S.open) return;
      var to = e.relatedTarget;
      if (to && !zone.contains(to) && !(S.open === 'replace' && to.id === 'replace-btn')) closePanels();
    });
    document.addEventListener('click', function (e) {
      if (!S.open) return;
      var t = e.target;
      if (t.closest('#navzone') || t.closest('#replace-btn') || t.closest('#dock') || t.closest('#search')) return;
      closePanels();
    });
  }

  var SR = { ready: null, P: [], C: [] };
  var FIN = { ready: null, F: null };
  function normPart(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function normText(s) { return String(s || '').toLowerCase().replace(/[“”″]/g, '"').replace(/\s+/g, ' ').trim(); }
  function fold(w) { return w.length > 4 && /s$/.test(w) && !/ss$/.test(w) ? w.slice(0, -1) : w; }
  var STOP = { the: 1, a: 1, an: 1, for: 1, with: 1, w: 1, and: 1, of: 1, to: 1, in: 1, on: 1, by: 1 };
  function words(s) {
    return normText(s).replace(/[^a-z0-9.]+/g, ' ').split(' ').filter(function (w) { return w && !STOP[w]; }).map(fold);
  }
  function loadFinder() {
    if (!FIN.ready) {
      FIN.ready = getJSON('finder.json').then(function (f) {
        f.byId = {};
        f.fields.forEach(function (fl, i) { fl.i = i; f.byId[fl.id] = fl; });
        FIN.F = f;
        return f;
      });
    }
    return FIN.ready;
  }
  function loadSearch() {
    if (!SR.ready) {
      SR.ready = Promise.all([getJSON('search-index.json'), loadFinder()]).then(function (res) {
        var ix = res[0], base = ix.imgBase;
        SR.P = ix.products.map(function (p, i) {

          var tp = p[9] || '';
          return { t: p[0], part: tp || p[1] || '', mfg: p[1] || '', h: p[2], img: p[3] ? base + p[3] + '?width=160' : '', qs: !!p[4], kind: p[5], price: p[6], o: p[7], i: i,
            dia: normText(p[8] || ''), np: normPart(tp || p[1]), nm: tp ? normPart(p[1]) : '', nt: normText(p[0]) };
        });
        SR.C = ix.collections.filter(function (c) { return c[2] > 0; }).map(function (c) { return { t: c[0], h: c[1], n: c[2], u: c[3] || '', w: words(c[0]) }; });
      });
    }
    return SR.ready;
  }
  function prodURL(p) { return '/products/' + p.h; }
  function collURL(c) { return c.u || '/collections/' + c.h; }
  function searchURL(q) { return '/search?q=' + encodeURIComponent(q); }

  function goURL(q) {
    if (SR.P && SR.P.length) {
      var pm = partMatches(q); if (pm.exact.length === 1) return prodURL(pm.exact[0]);
      
      var nq = normPart(q), alt = nq.length >= 5 && !pm.exact.length ? SR.P.filter(function (p) { return p.nm === nq; }) : [];
      if (alt.length === 1) return prodURL(alt[0]);
    }
    return searchURL(q);
  }

  function partMatches(q) {
    var nq = normPart(q);
    var out = { exact: [], prefix: [] };
    if (nq.length < 3) return out;
    SR.P.forEach(function (p) {
      if (!p.np) return;
      if (p.np === nq) out.exact.push(p);
      
      else if (p.np.indexOf(nq) === 0 || (nq.length >= 5 && p.np.indexOf(nq) > 0) || (p.nm && p.nm.indexOf(nq) === 0)) out.prefix.push(p);
    });
    out.prefix.sort(function (a, b) {
      var ap = a.np.indexOf(nq) === 0 ? 0 : 1, bp = b.np.indexOf(nq) === 0 ? 0 : 1;
      return ap - bp || (a.np.length - b.np.length) || (b.o - a.o) || (a.i - b.i);
    });
    return out;
  }

  var FRAC = { '5': '1/2', '25': '1/4', '75': '3/4', '625': '5/8', '375': '3/8', '125': '1/8', '875': '7/8' };
  function dec2frac(n) {
    var m = String(n).match(/^(\d+)\.(\d+)$/);
    if (!m) return String(n);
    return FRAC[m[2]] ? m[1] + '-' + FRAC[m[2]] : String(n);
  }
  var CASTER_WORD = /\b(swivel|rigid|fixed|brake|lock|plate|stem|caster|wheel|rubber|poly|polyurethane|urethane|nylon|phenolic|steel|iron|metal|duty|grip|threaded|kingpin|composite|polyolefin)/;
  
  function queryTokens(q) {
    var s = ' ' + normText(q) + ' ';
    var seriesQ = /\bseries\b/.test(s);
    s = s.replace(/(\d+)\s*-\s*(\d+)\s*\/\s*(\d+)\s*(?:"|''|-?\s*inch(?:es)?\b|\s?in\b)?/g, function (m, a, b, c) { return ' ' + a + '-' + b + '/' + c + '" '; })
      .replace(/(\d+)\s+(\d)\s*\/\s*(\d+)\s*(?:"|''|-?\s*inch(?:es)?\b|\s?in\b)?/g, function (m, a, b, c) { return ' ' + a + '-' + b + '/' + c + '" '; })
      .replace(/(\d+(?:\.\d+)?)\s*(?:"|''|-?\s*inch(?:es)?\b|\s?in\b)/g, function (m, n) { return ' ' + dec2frac(n) + '" '; });
    var toks = s.replace(/[^a-z0-9"\/\-. ]+/g, ' ').split(' ').filter(function (w) { return w && !STOP[w] && w !== '"'; });
    var casterish = CASTER_WORD.test(s) && !seriesQ;
    return toks.map(function (w) {
      if (casterish && /^\d+(\.\d+)?$/.test(w) && +w <= 12) return dec2frac(w) + '"';
      return w.indexOf('"') >= 0 ? w : fold(w);
    });
  }
  var SYN = { brake: ['brake', 'lock'], lock: ['lock', 'brake'], locking: ['lock', 'brake'], urethane: ['urethane'], polyurethane: ['polyurethane', 'urethane'],
    fixed: ['rigid'], caster: ['caster'], wheel: ['wheel'], stainles: ['stainless'], stainless: ['stainless'] };
  var reCache = {};
  function sizeRe(n) {
    if (!reCache[n]) reCache[n] = new RegExp('(^|[^0-9/\\-.])' + n.replace(/[\/\-.]/g, '\\$&') + '\\s*"');
    return reCache[n];
  }
  function tokHit(p, tok) {
    
    if (tok.slice(-1) === '"') return p.dia ? p.dia === tok : sizeRe(tok.slice(0, -1)).test(p.nt);
    var syn = SYN[tok] || [tok];
    for (var i = 0; i < syn.length; i++) if (p.nt.indexOf(syn[i]) >= 0) return true;
    var np = normPart(tok);
    return np.length >= 3 && p.np && p.np.indexOf(np) >= 0;
  }
  function productMatches(q, skip, max) {
    var toks = queryTokens(q);
    if (!toks.length) return [];
    var need = toks.length > 2 ? toks.length - 1 : toks.length;
    var wantsBrake = /\b(brakes?|braking|locks?|locking)\b/.test(normText(q));
    var hits = [];
    for (var i = 0; i < SR.P.length; i++) {
      var p = SR.P[i];
      if (skip[p.h]) continue;
      if (wantsBrake && /\bwithout (a )?(lock|brake)/.test(p.nt)) continue;
      var m = 0;
      for (var j = 0; j < toks.length; j++) if (tokHit(p, toks[j])) m++;
      if (m >= need) hits.push({ p: p, m: m });
      if (hits.length > 400) break;
    }
    hits.sort(function (a, b) { return b.m - a.m || a.p.i - b.p.i; });
    return hits.slice(0, max || 6).map(function (x) { return x.p; });
  }
  function catMatches(q) {
    var ws = words(q).filter(function (w) { return !/^\d{5,}/.test(w); });
    if (!ws.length) return [];
    var out = [];
    SR.C.forEach(function (c) {
      var m = 0;
      ws.forEach(function (w) {
        if (c.w.indexOf(w) >= 0 || (w.length >= 4 && c.w.some(function (t) { return t.indexOf(w) === 0; }))) m++;
      });
      if (m) out.push({ c: c, m: m });
    });
    out.sort(function (a, b) { return b.m - a.m || b.c.n - a.c.n; });
    var best = out.length ? out[0].m : 0;
    return out.filter(function (x) { return x.m >= Math.max(1, best - 1); }).slice(0, 4).map(function (x) { return x.c; });
  }

  function parseSpec(q) {
    var F = FIN.F;
    if (!F) return null;
    var s = ' ' + normText(q).replace(/[^a-z0-9"\/\-. ]+/g, ' ') + ' ';
    var sel = F.fields.map(function () { return []; });
    var bits = {};
    function setVals(fid, labels) {
      var fl = F.byId[fid];
      if (!fl) return;
      labels.forEach(function (lab) {
        var j = -1;
        fl.values.forEach(function (v, k) { if (v.label === lab || v.value === lab) j = k; });
        if (j >= 0 && sel[fl.i].indexOf(j) < 0) sel[fl.i].push(j);
      });
    }
    var size = queryTokens(q).filter(function (t) { return t.slice(-1) === '"'; })[0];
    if (size) { setVals('diameter', [size]); if (sel[F.byId.diameter.i].length) bits.size = size; }
    var brake = /\b(brakes?|braking|locks?|locking)\b/.test(s), swivel = /\bswivels?\b/.test(s), rigid = /\b(rigid|fixed)\b/.test(s);
    if (swivel && brake) setVals('type', ['Swivel with Brake']);
    else if (rigid && brake) setVals('type', ['Rigid with Brake']);
    else if (brake) setVals('type', ['Swivel with Brake', 'Rigid with Brake']);
    else if (swivel) setVals('type', ['Swivel']);
    else if (rigid) setVals('type', ['Rigid']);
    bits.type = swivel ? 'swivel' : rigid ? 'rigid' : '';
    bits.brake = brake;
    var mount = '';
    if (/\b(top\s?plate|plate)\b/.test(s)) { setVals('mount', ['Top Plate']); mount = 'top plate'; }
    else if (/\bthreaded\b/.test(s)) { setVals('mount', ['Threaded Stem']); mount = 'threaded stem'; }
    else if (/\bgrip\s?-?ring\b/.test(s)) { setVals('mount', ['Grip Ring Stem', 'Grip Ring']); mount = 'grip ring stem'; }
    else if (/\bexpand/.test(s)) { setVals('mount', ['Expanding Adapter Stem']); mount = 'expanding adapter stem'; }
    else if (/\bhollow\b|\bkingpin\b/.test(s)) { setVals('mount', ['Hollow Kingpin']); mount = 'hollow kingpin'; }
    else if (/\bpipe\b/.test(s)) { setVals('mount', ['Pipe Thread Stem']); mount = 'pipe thread stem'; }
    else if (/\bmodular\b/.test(s)) { setVals('mount', ['Modular Stem']); mount = 'modular stem'; }
    else if (/\bstems?\b/.test(s)) {
      setVals('mount', F.byId.mount.values.filter(function (v) { return /stem|grip ring/i.test(v.label); }).map(function (v) { return v.label; }));
      mount = 'stem';
    }
    bits.mount = mount;
    var mat = '';
    if (/\brubber\b/.test(s)) mat = 'Rubber';
    else if (/\b(poly|polyurethane|urethane)\b/.test(s)) mat = 'Polyurethane';
    else if (/\b(polyolefin|polypropylene|plastic)\b/.test(s)) mat = 'Polyolefin';
    else if (/\bnylon\b/.test(s)) mat = 'Nylon';
    else if (/\bphenolic\b/.test(s)) mat = 'Phenolic';
    else if (/\bcomposite\b/.test(s)) mat = 'Composite';
    else if (/\b(metal|cast iron|iron)\b/.test(s) || (/\bsteel\b/.test(s) && !/\bstainless\b/.test(s))) mat = 'Metal';
    if (mat) { setVals('material', [mat]); bits.mat = mat.toLowerCase(); }
    var duty = '';
    if (/\blight\b/.test(s)) { setVals('load', ['Up to 350 lb', 'Up to 350 lbs']); duty = 'light duty'; }
    else if (/\bmedium\b/.test(s)) { setVals('load', ['350 to 1,500 lb', '350 to 1,500 lbs']); duty = 'medium duty'; }
    else if (/\bheavy\b/.test(s)) { setVals('load', ['Over 1,500 lb', 'Over 1,500 lbs']); duty = 'heavy duty'; }
    bits.duty = duty;
    var used = sel.filter(function (x) { return x.length; }).length;
    if (!used) return null;
    var sets = sel.map(function (x) { return x.length ? x : null; });
    var n = 0;
    F.rows.forEach(function (r) {
      for (var i = 0; i < sets.length; i++) if (sets[i] && sets[i].indexOf(r[i]) < 0) return;
      n++;
    });
    if (!n) return null;
    var label = [bits.size, bits.duty, bits.mat, bits.type, bits.mount, 'casters'].filter(Boolean).join(' ') + (bits.brake ? ' with brake' : '');
    label = label.charAt(0).toUpperCase() + label.slice(1);
    var ps = [];
    sel.forEach(function (vals, i) {
      vals.slice().sort(function (a, b) { return a - b; }).forEach(function (v) {
        ps.push(F.fields[i].param + '=' + encodeURIComponent(F.fields[i].values[v].value));
      });
    });
    return { label: label, n: n, url: F.base + '?' + ps.join('&') };
  }

  function runSearch(q) {
    var res = { exact: [], prefixParts: [], spec: null, cats: [], prods: [] };
    q = q.trim();
    if (!q) return res;
    var pm = partMatches(q);
    res.exact = pm.exact.slice(0, 2);
    var looksPart = /\d/.test(q) && /[a-z]/i.test(q) && !/\s/.test(q.trim()) && normPart(q).length >= 5;
    if (!res.exact.length && looksPart) res.prefixParts = pm.prefix.slice(0, 3);
    res.spec = parseSpec(q);
    res.cats = catMatches(q);
    var skip = {};
    res.exact.concat(res.prefixParts).forEach(function (p) { skip[p.h] = 1; });
    res.prods = productMatches(q, skip, res.spec || res.cats.length ? 4 : 6);
    return res;
  }

  function mark(text, q) {
    var t = esc(text);
    var ws = normText(q).split(' ').filter(function (w) { return w.length > 1; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!ws.length) return t;
    var done = {};
    try {
      return t.replace(new RegExp('(' + ws.join('|') + ')', 'ig'), function (m) {
        var k = m.toLowerCase();
        if (done[k]) return m;
        done[k] = 1;
        return '<mark>' + m + '</mark>';
      });
    } catch (e) { return t; }
  }
  
  function bareTitle(p) {
    var t = p.t;
    [p.part, p.mfg].forEach(function (code) {
      if (!code) return;
      var c = code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      t = t.replace(new RegExp('\\s*(?:[-\u2013]\\s*|;?\\s*(?:CC\\s+|Caster Central\\s+)?Part\\s*#\\s*-?\\s*:?\\s*)' + c + '\\s*$', 'i'), '');
    });
    return t;
  }
  function markPart(part, q) {
    var nq = normPart(q), out = '', k = 0, matched = 0;
    var start = normPart(part).indexOf(nq);
    if (!nq || start < 0) return esc(part);
    for (var i = 0; i < part.length; i++) {
      var ch = part[i], isAl = /[a-z0-9]/i.test(ch);
      var inside = isAl && k >= start && matched < nq.length;
      out += inside ? '<mark>' + esc(ch) + '</mark>' : esc(ch);
      if (isAl) { if (k >= start && matched < nq.length) matched++; k++; }
    }
    return out.replace(/<\/mark><mark>/g, '');
  }
  function prodRow(p, q, cls) {
    return '<a class="sr ' + (cls || '') + '" role="option" href="' + esc(prodURL(p)) + '" ' + EXT + ' data-part="' + esc(p.part) + '">' +
      '<span class="well well--sm">' + imgTag(p.img, 160) + '</span>' +
      '<span class="sr__b"><span class="sr__t">' + mark(bareTitle(p), q) + '</span>' +
      '<span class="sr__m">' + (p.part ? '<code>' + markPart(p.part, q) + '</code>' : '') + (p.price ? '<b>' + esc(p.price) + '</b>' : '<span class="sr__q">Request a quote</span>') +
      (p.qs ? '<span class="qs-badge">QuickShip</span>' : '') + '</span></span></a>';
  }
  function resultsHTML(res, q) {
    var h = '';
    function sec(title, body) { var hid = uid('srh'); return '<div class="sr-sec" role="group" aria-labelledby="' + hid + '"><p class="sr-sec__h" id="' + hid + '">' + title + '</p>' + body + '</div>'; }
    if (res.exact.length) h += sec('Exact part', res.exact.map(function (p) { return prodRow(p, q, 'sr--exact'); }).join(''));
    if (res.prefixParts.length) h += sec('Part numbers', res.prefixParts.map(function (p) { return prodRow(p, q, 'sr--part'); }).join(''));
    if (res.spec) {
      h += sec('Shop by spec', '<a class="sr sr--spec" role="option" href="' + esc(res.spec.url) + '" ' + EXT + '>' + I.ruler +
        '<span class="sr__b"><span class="sr__t">' + esc(res.spec.label) + '</span><span class="sr__m">Filtered on the store</span></span><em class="sr__n">' + fmt(res.spec.n) + '</em></a>');
    }
    if (res.cats.length) {
      h += sec('Categories', res.cats.map(function (c) {
        return '<a class="sr sr--cat" role="option" href="' + esc(collURL(c)) + '" ' + EXT + '><span class="sr__t">' + mark(c.t, q) + '</span><em class="sr__n">' + fmt(c.n) + '</em></a>';
      }).join(''));
    }
    if (res.prods.length) h += sec('Products', res.prods.map(function (p) { return prodRow(p, q); }).join(''));
    var empty = h ? '' : '<p class="sr-empty">No quick match for <b>' + esc(q) + '</b>. Press Enter to search the whole store, or ' +
      '<a href="' + esc(D.nav.header.quoteUrl) + '" ' + EXT + '>send a photo</a> and we will find it.</p>';
    h += '<a class="sr sr--all" role="option" href="' + esc(searchURL(q)) + '" ' + EXT + '>See all results for &ldquo;' + esc(q) + '&rdquo; ' + I.arrow + '</a>';
    return { list: h, note: empty };
  }
  function hintHTML() {
    var tries = ['370TM06501R', '4 inch swivel brake', 'grip ring stem'];
    return '<div class="sr-hint"><p>Search by part number, or by size, type and mount.</p><p class="tries"><span>Try</span>' +
      tries.map(function (t) { return '<button type="button" class="try" data-try="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</p></div>';
  }

  function makeSearch(input, pop, opt) {
    opt = opt || {};
    var active = -1, lastQ = null;
    var note = $('.pop__note', pop), list = $('[role="listbox"]', pop);
    function fill(n, l) { note.innerHTML = n || ''; note.hidden = !n; list.innerHTML = l || ''; list.hidden = !l; }
    function opts() { return $$('.sr', list); }
    function setActive(i) {
      var o = opts();
      o.forEach(function (x, k) { x.classList.toggle('is-act', k === i); x.id = x.id || uid('sro'); });
      active = i;
      if (i >= 0 && o[i]) { input.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }
    function show() { pop.hidden = false; input.setAttribute('aria-expanded', 'true'); if (opt.onShow) opt.onShow(); }
    function hide() { pop.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; if (opt.onHide) opt.onHide(); }
    function update() {
      var q = input.value;
      if (q === lastQ && !pop.hidden) return;
      lastQ = q;
      if (!q.trim()) { fill(hintHTML(), ''); active = -1; show(); return; }
      if (!SR.P.length) { fill('<p class="sr-empty">Loading the catalog&hellip;</p>', ''); show(); loadSearch().then(function () { lastQ = null; update(); }); return; }
      var r = resultsHTML(runSearch(q), q);
      fill(r.note, r.list);
      active = -1;
      show();
    }
    input.addEventListener('focus', function () { loadSearch(); closePanels(); closeHelp(); update(); });
    input.addEventListener('input', update);
    input.addEventListener('keydown', function (e) {
      var o = opts();
      if (e.key === 'ArrowDown') { e.preventDefault(); if (pop.hidden) update(); setActive(Math.min(o.length - 1, active + 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(-1, active - 1)); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        var url = active >= 0 && o[active] ? o[active].href : (input.value.trim() ? goURL(input.value.trim()) : null);
        if (url) window.location.assign(url);
      } else if (e.key === 'Escape') {
        if (!pop.hidden) { e.preventDefault(); hide(); }
      }
    });
    pop.addEventListener('mousedown', function (e) { if (e.target.closest('.try, .sr')) e.preventDefault(); });
    pop.addEventListener('click', function (e) {
      var t = e.target.closest('.try');
      if (t) { input.value = t.getAttribute('data-try'); input.focus(); update(); }
    });
    pop.addEventListener('mousemove', function (e) {
      var o = e.target.closest('.sr');
      if (o) { var i = opts().indexOf(o); if (i !== active) setActive(i); }
    });
    if (!opt.inline) {
      
      var box = input.closest('.search') || pop.parentNode;
      box.addEventListener('focusout', function () {
        setTimeout(function () { if (!box.contains(document.activeElement)) hide(); }, 120);
      });
    }
    var form = input.closest('form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (input.value.trim()) window.location.assign(goURL(input.value.trim())); });
    return {
      input: input, pop: pop, hide: hide, update: function () { lastQ = null; update(); },
      type: function (text, delay) {
        input.focus();
        input.value = '';
        lastQ = null;
        update();
        var i = 0;
        return loadSearch().then(function step() {
          if (i >= text.length) return null;
          input.value += text[i++];
          update();
          return sleep(delay || 50).then(step);
        });
      }
    };
  }
  var deskSearch = null;
  function closeSearch() { if (deskSearch && !deskSearch.pop.hidden) deskSearch.hide(); }

  var DOOR_ICON = { part: I.hash, measure: I.ruler, photo: I.camera, equipment: I.equip };
  function replacePanelHTML() {
    var r = D.nav.replace;
    return '<div class="panel panel--replace" id="panel-replace" data-id="replace" role="region" aria-labelledby="replace-title" hidden>' +
      '<div class="pg no-aside">' +
      '<div class="rail rail--doors" role="tablist" aria-orientation="vertical" aria-label="' + esc(r.title) + '">' +
      '<p class="rail__title" id="replace-title">' + esc(r.title) + '</p>' +
      r.doors.map(function (d, i) {
        return '<button type="button" class="rail__row door' + (i ? '' : ' is-on') + '" role="tab" id="tab-replace-' + d.id + '" aria-selected="' + (i ? 'false' : 'true') +
          '" aria-controls="lens-replace-' + d.id + '" tabindex="' + (i ? -1 : 0) + '" data-lens="' + d.id + '">' + (DOOR_ICON[d.id] || '') +
          '<span><b>' + esc(d.label) + '</b><small>' + esc(d.text) + '</small></span></button>';
      }).join('') + '</div>' +
      '<div class="stage">' + r.doors.map(function (d, i) {
        return '<section class="lens lens--door' + (i ? '' : ' is-on') + '" id="lens-replace-' + d.id + '" role="tabpanel" aria-labelledby="tab-replace-' + d.id + '" data-lens="' + d.id + '">' +
          doorHead(d) + doorBody(d) + '</section>';
      }).join('') + '</div></div></div>';
  }
  
  function doorHead(d) { return '<div class="lens__hd"><h3>' + esc(d.heading || d.label) + '</h3></div>'; }

  function photoFig() {
    var C = window.CCSizeIcon;
    var ico = typeof C === 'function' ? C(6, { cls: 'photo__ico', label: ' ', width: 200, height: 184, dim: false, k: C.pxPerInch(184) * 1.75 }).replace(/ role="img" aria-label=" "/, ' aria-hidden="true" focusable="false"') : '';
    return '<div class="photo__fig" aria-hidden="true">' + ico +
      '<span class="photo__n photo__n--1">1</span><span class="photo__n photo__n--2">2</span><span class="photo__n photo__n--3">3</span></div>';
  }
  function doorBody(d) {
    var h = D.nav.header;
    if (d.id === 'part') return '<div class="partq" data-partq></div>';
    if (d.id === 'measure') return '<div data-finder><p class="sr-empty">Loading&hellip;</p></div>';
    if (d.id === 'photo') {
      return '<div class="photo"><div class="photo__copy">' +
        '<ol class="photo__steps"><li><span><b>The whole caster</b>, from the side</span></li><li><span><b>The plate or stem</b>, next to a tape measure</span></li><li><span><b>The weight</b>, per caster</span></li></ol>' +
        '<a class="ccn-btn btn--primary" href="' + esc(d.url) + '" ' + EXT + '>' + I.camera + ' Send a photo</a>' +
        '<p class="help">Or call <a href="' + esc(h.phoneHref) + '">' + esc(h.phone) + '</a>, ' + esc(h.hours) + '.</p></div>' +
        photoFig() + '</div>';
    }
    if (d.id === 'equipment') {
      var lanes = (d.items || []).concat(d.moreItems || []);
      var rows = Math.ceil(lanes.length / 2);
      return '<div class="equip"><ul class="equip__list" style="--rows:' + rows + '">' + lanes.map(function (it, i) {
        return '<li' + (i % rows ? '' : ' class="is-top"') + '><a href="' + esc(it.url) + '" ' + EXT + '><span>' + esc(it.label) + '</span>' +
          (it.count != null ? '<em>' + fmt(it.count) + '</em>' : '') + I.arrow + '</a></li>';
      }).join('') + '</ul>' + helpLine('Not on the list?') + '</div>';
    }
    return '';
  }

  function partFig() {
    var C = window.CCSizeIcon;
    if (typeof C !== 'function') return '';
    var ico = C(5, { cls: 'partq__ico', label: ' ', width: 180, height: 166, dim: false, k: C.pxPerInch(166) * 2 }).replace(/ role="img" aria-label=" "/, ' aria-hidden="true" focusable="false"');
    return '<figure class="partq__fig" aria-hidden="true">' + ico + '<span class="partq__tag partq__tag--plate">Top plate</span><span class="partq__tag partq__tag--leg">Yoke leg</span>' +
      '<figcaption>Look on the top plate and the yoke legs</figcaption></figure>';
  }
  
  function makePartLookup(root) {
    var id = uid('pq');
    var bs = [];
    D.nav.bar.forEach(function (b) { if (b.id === 'casters') bs = (b.bestSellers || []).map(function (p) { return p.part; }).filter(Boolean); });
    var tries = ['370TM06501R'].concat(bs.slice(0, 2));
    var door = D.nav.replace.doors.filter(function (x) { return x.id === 'part'; })[0] || {};
    root.innerHTML = '<label class="vh" for="' + id + '">Part number</label>' +
      '<div class="partq__main"><div class="partq__box">' + I.hash + '<input id="' + id + '" type="search" placeholder="Paste a part number" autocomplete="off" autocapitalize="characters" spellcheck="false"></div>' +
      (door.body ? '<p class="partq__hint">' + esc(door.body) + '</p>' : '') +
      '<p class="tries"><span>Try</span>' + tries.map(function (t) { return '<button type="button" class="try" data-try="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</p>' +
      '<div class="partq__res" aria-live="polite"></div></div>' + partFig();
    var input = $('input', root), out = $('.partq__res', root);
    function render() {
      var q = input.value.trim();
      if (normPart(q).length < 3) { out.innerHTML = ''; return; }
      var pm = partMatches(q);
      var rows = pm.exact.map(function (p) { return prodRow(p, q, 'sr--exact', '<span class="sr__tag">Exact match</span>'); })
        .concat(pm.prefix.slice(0, pm.exact.length ? 3 : 5).map(function (p) { return prodRow(p, q, 'sr--part'); }));
      out.innerHTML = rows.length ? rows.join('') : '<p class="sr-empty">No part number matches <b>' + esc(q) + '</b>. ' +
        'Try By measurements, or <a href="' + esc(D.nav.header.quoteUrl) + '" ' + EXT + '>send a photo</a>.</p>';
    }
    input.addEventListener('focus', loadSearch);
    input.addEventListener('input', function () { loadSearch().then(render); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); var a = $('.sr', out); if (a) window.location.assign(a.href); }
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('.try');
      if (t) { input.value = t.getAttribute('data-try'); input.focus(); loadSearch().then(render); }
    });
    return { input: input, render: render };
  }

  function facets(F, sel) {
    var nf = F.fields.length;
    var counts = F.fields.map(function (fl) { return fl.values.map(function () { return 0; }); });
    var total = 0;
    for (var r = 0; r < F.rows.length; r++) {
      var row = F.rows[r], fails = 0, fi = -1;
      for (var i = 0; i < nf; i++) {
        if (sel[i] >= 0 && row[i] !== sel[i]) { fails++; fi = i; if (fails > 1) break; }
      }
      if (fails === 0) { total++; for (var k = 0; k < nf; k++) if (row[k] >= 0) counts[k][row[k]]++; }
      else if (fails === 1 && row[fi] >= 0) counts[fi][row[fi]]++;
    }
    return { total: total, counts: counts };
  }
  function finderURL(F, sel) {
    var ps = [];
    sel.forEach(function (v, i) { if (v >= 0) ps.push(F.fields[i].param + '=' + encodeURIComponent(F.fields[i].values[v].value)); });
    return F.base + (ps.length ? '?' + ps.join('&') : '');
  }
  var finders = [];
  function makeFinder(root) {
    var F = FIN.F, id = uid('ff');
    var sel = F.fields.map(function () { return -1; });
    var base = facets(F, sel);
    var orderBy = { mount: 'count', material: 'count' };
    var order = F.fields.map(function (fl, i) {
      var idx = fl.values.map(function (v, j) { return j; });
      if (orderBy[fl.id]) idx.sort(function (a, b) { return base.counts[i][b] - base.counts[i][a]; });
      return idx;
    });
    root.innerHTML = '<div class="finder"><div class="finder__fields">' + F.fields.map(function (fl, i) {
      return '<div class="ff" role="group" aria-labelledby="' + id + '-' + i + '"><span class="ff__l" id="' + id + '-' + i + '">' + esc(fl.label) + '</span><div class="ff__chips">' +
        order[i].map(function (j) {
          return '<button type="button" class="chip" data-f="' + i + '" data-v="' + j + '" aria-pressed="false"><span>' + esc(fl.values[j].label) + '</span><em aria-hidden="true"></em></button>';
        }).join('') + '</div></div>';
    }).join('') + '</div>' +
      '<div class="finder__out"><p class="finder__n"><b>0</b><span>casters match</span></p><p class="vh" aria-live="polite" data-live></p>' +
      '<a class="ccn-btn btn--primary finder__go" ' + EXT + '>Show casters</a>' +
      '<button type="button" class="finder__reset">Reset</button>' +
      '<p class="finder__note">Opens the store with these filters set.</p></div></div>';
    var chips = $$('.chip', root), num = $('.finder__n b', root), noun = $('.finder__n span', root), live = $('[data-live]', root), go = $('.finder__go', root), shown = 0, tw = 0, said = null;
    function tween(to) {
      cancelAnimationFrame(tw);
      var from = shown, t0 = performance.now();
      (function step(t) {
        var k = Math.min(1, (t - t0) / 220);
        shown = Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3)));
        num.textContent = fmt(shown);
        if (k < 1) tw = requestAnimationFrame(step);
      })(t0);
    }
    function update() {
      var f = facets(F, sel);
      chips.forEach(function (c) {
        var fi = +c.getAttribute('data-f'), vi = +c.getAttribute('data-v');
        var n = f.counts[fi][vi], on = sel[fi] === vi;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.disabled = !on && n === 0;
        c.setAttribute('data-count', n);
        $('em', c).textContent = fmt(n);
        c.setAttribute('aria-label', F.fields[fi].values[vi].label + ', ' + plural(n, 'caster', 'casters'));
      });
      tween(f.total);
      noun.textContent = f.total === 1 ? 'caster matches' : 'casters match';
      
      var msg = plural(f.total, 'caster matches', 'casters match');
      if (said !== null && msg !== said) live.textContent = msg;
      said = msg;
      go.href = finderURL(F, sel);
      go.textContent = 'Show ' + plural(f.total, 'caster', 'casters');
      root.setAttribute('data-total', f.total);
    }
    root.addEventListener('click', function (e) {
      var c = e.target.closest('.chip');
      if (c && !c.disabled) {
        var fi = +c.getAttribute('data-f'), vi = +c.getAttribute('data-v');
        sel[fi] = sel[fi] === vi ? -1 : vi;
        update();
      }
      if (e.target.closest('.finder__reset')) { sel = sel.map(function () { return -1; }); update(); }
    });
    update();
    var api = {
      root: root, sel: sel,
      pick: function (fieldId, label) {
        var fl = F.byId[fieldId];
        if (!fl) return false;
        var j = -1, want = String(label).replace(/\bw\/\s*/i, 'with ').toLowerCase();
        fl.values.forEach(function (v, k) { if (v.label === label || v.label.toLowerCase() === want) j = k; });
        if (j < 0) return false;
        sel[fl.i] = j;
        update();
        return true;
      },
      reset: function () { for (var i = 0; i < sel.length; i++) sel[i] = -1; update(); },
      total: function () { return +root.getAttribute('data-total'); }
    };
    finders.push(api);
    return api;
  }
  var deskFinder = null, deskPart = null;
  function initReplace() {
    var p = $('#panel-replace');
    deskPart = makePartLookup($('[data-partq]', p));
    loadFinder().then(function () { deskFinder = makeFinder($('[data-finder]', p)); layoutPanel(p); })
      .catch(function (e) { console.warn(e); });
    var btn = $('#replace-btn');
    btn.addEventListener('click', function () {
      if (S.open === 'replace') { closePanels(); return; }
      openPanel('replace', { by: 'click' });
      setTimeout(function () { if (S.replaceDoor === 'part' && deskPart) deskPart.input.focus(); }, 60);
    });
    
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && !e.shiftKey && S.open === 'replace' && enterPanel('replace')) e.preventDefault();
    });
  }
  function openReplace(door) {
    if (isPhone()) { openDrawer('replace'); if (door) phoneDoor(door); return Promise.resolve(); }
    openPanel('replace', { by: 'click' });
    if (door) setLens('replace', door);
    return loadFinder();
  }

  function closeHelp() {
    var b = $('#help-btn'), m = $('#help-menu');
    if (b && m && !m.hidden) { m.hidden = true; b.setAttribute('aria-expanded', 'false'); }
  }
  function bindHelp() {
    var b = $('#help-btn'), m = $('#help-menu');
    if (!b) return;
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = m.hidden;
      closePanels(); closeSearch();
      m.hidden = !open;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var a = $('a', m); if (a) a.focus(); }
    });
    m.addEventListener('keydown', function (e) {
      var as = $$('a', m), i = as.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); as[(i + 1) % as.length].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); as[(i + as.length - 1) % as.length].focus(); }
      if (e.key === 'Escape') { closeHelp(); b.focus(); }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('#help-dd')) closeHelp(); });
  }

  var drawerSearch = null, phoneFinder = null, phonePart = null;
  function drawerHTML() {
    var nav = D.nav, h = nav.header, q = nav.quickship;
    var rows = nav.bar.map(function (b) {
      return '<li><button type="button" class="dr__row" data-go="' + b.id + '"><span>' + esc(b.label) + '</span>' + I.chevR + '</button></li>';
    }).join('');
    var levels = nav.bar.map(function (b) {
      var tabs = b.lenses.length > 1 ? '<div class="dr__tabs" role="group" aria-label="Shop ' + esc(b.label) + ' by">' + b.lenses.map(function (l, i) {
        return '<button type="button" class="dr__tab" aria-pressed="' + (i ? 'false' : 'true') + '" data-lens="' + l.id + '">' + esc(l.label) + '</button>';
      }).join('') + '</div>' : '';
      var lenses = b.lenses.map(function (l, i) {
        var xl = l.layout === 'sizes' ? sizeXlink(b) : '';
        return '<div class="dr__lens lens--' + l.layout + (i ? '' : ' is-on') + '" data-lens="' + l.id + '">' + lensBody(b, l) + (xl ? '<div class="dr__xlink">' + xl + '</div>' : '') + '</div>';
      }).join('');
      var bs = b.bestSellers && b.bestSellers.length ? '<div class="dr__best"><p class="ccn-eyebrow">Most ordered</p>' + bestRows(b.bestSellers) + '</div>' : '';
      var all = b.viewAll ? '<a class="dr__all" href="' + esc(b.url) + '" ' + EXT + '>' + esc(b.viewAll) + (!b.hideCounts && b.viewAllCount ? ' <em>' + fmt(b.viewAllCount) + '</em>' : '') + I.arrow + '</a>' : '';
      return '<section class="dr__lvl" data-lvl="' + b.id + '" aria-label="' + esc(b.label) + '"><div class="dr__hd"><button type="button" class="dr__back" aria-label="Back to menu">' + I.chevL +
        '</button><b>' + esc(b.title) + '</b></div>' + tabs + '<div class="dr__lenses">' + lenses + '</div>' + all + bs + '</section>';
    }).join('');
    var r = nav.replace;
    var replaceLvl = '<section class="dr__lvl" data-lvl="replace" aria-label="' + esc(r.title) + '"><div class="dr__hd"><button type="button" class="dr__back" aria-label="Back to menu">' + I.chevL +
      '</button><b>' + esc(r.title) + '</b></div><div class="dr__tabs" role="group" aria-label="' + esc(r.title) + '">' + r.doors.map(function (d, i) {
        return '<button type="button" class="dr__tab" aria-pressed="' + (i ? 'false' : 'true') + '" data-door="' + d.id + '">' + esc(d.label.replace(/^By /, '')) + '</button>';
      }).join('') + '</div><div class="dr__lenses">' + r.doors.map(function (d, i) {
        return '<div class="dr__lens lens--door' + (i ? '' : ' is-on') + '" data-door="' + d.id + '">' + doorHead(d) + doorBody(d) + '</div>';
      }).join('') + '</div></section>';
    var util = nav.utility.items.map(function (u) { return '<li><a href="' + esc(u.url) + '" ' + EXT + '>' + esc(u.label) + '</a></li>'; }).join('');
    return '<div class="dr__top"><button type="button" class="dr__close" aria-label="Close menu">' + I.close + '</button>' +
      '<img class="dr__logo" src="' + esc($('.mast__logo img').getAttribute('src')) + '" width="150" height="35" alt="Caster Central">' +
      '<a class="dr__cart" href="/cart" ' + EXT + ' aria-label="Cart">' + $('.mast__cart').innerHTML + '</a></div>' +
      '<div class="dr__search"><form class="search__form" role="search"><label class="vh" for="dq">Search the store</label>' +
      '<input id="dq" type="search" placeholder="Part number or size" autocomplete="off" autocapitalize="off" spellcheck="false" role="combobox" aria-expanded="false" aria-controls="dpop-list" aria-autocomplete="list">' +
      '<button class="search__go" type="submit" aria-label="Search">' + svg('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/>', 20) + '</button></form></div>' +
      '<div class="dr__body"><div class="dr__results" id="dpop" hidden><div class="pop__note" hidden></div><div class="pop__list" id="dpop-list" role="listbox" aria-label="Search suggestions" hidden></div></div>' +
      '<section class="dr__lvl dr__root is-on" data-lvl="root" aria-label="Menu">' +
      '<button type="button" class="dr__replace" data-go="replace">' + I.wrench + '<span>' + esc(r.title) + '</span>' + I.chevR + '</button>' +
      '<ul class="dr__rows">' + rows + '</ul>' +
      '<a class="dr__qs" href="' + esc(q.url) + '" ' + EXT + '><i class="qs__dot" aria-hidden="true"></i><span><b>' + esc(q.label) + '</b><small>' + fmt(q.count) + ' ' + esc(q.noun || 'products') + ' &middot; ' + esc(q.sub) + '</small></span>' + I.chevR + '</a>' +
      '<div class="dr__foot"><a class="dr__call" href="' + esc(h.phoneHref) + '">' + I.phone + '<span><b>Call ' + esc(h.phone) + '</b><small>' + esc(h.hours) + '</small></span></a>' +
      '<a class="dr__quote" href="' + esc(h.quoteUrl) + '" ' + EXT + '>' + I.quote + '<span><b>Request a quote</b></span></a>' +
      '<p class="ccn-eyebrow">' + esc(nav.utility.label) + '</p><ul class="dr__util">' + util + '</ul></div>' +
      '</section>' + levels + replaceLvl + '</div>';
  }
  function renderDrawer() {
    var dr = $('#ccn-drawer');
    if (dr.getAttribute('data-built')) return;
    dr.innerHTML = drawerHTML();
    dr.setAttribute('data-built', '1');
    var dq = $('#dq'), res = $('#dpop');
    drawerSearch = makeSearch(dq, res, { inline: true,
      onShow: function () { dr.classList.toggle('is-searching', !!dq.value.trim() || document.activeElement === dq); },
      onHide: function () { dr.classList.remove('is-searching'); } });
    dq.addEventListener('blur', function () { setTimeout(function () { if (!dq.value.trim() && document.activeElement !== dq) drawerSearch.hide(); }, 150); });
    dr.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.dr__close')) { closeDrawer(); return; }
      var go = t.closest('[data-go]');
      if (go) { goLevel(go.getAttribute('data-go')); return; }
      if (t.closest('.dr__back')) { goLevel('root'); return; }
      var tab = t.closest('.dr__tab');
      if (tab) {
        var lvl = tab.closest('.dr__lvl');
        $$('.dr__tab', lvl).forEach(function (x) { x.setAttribute('aria-pressed', x === tab ? 'true' : 'false'); });
        var key = tab.getAttribute('data-lens') ? 'data-lens' : 'data-door';
        $$('.dr__lens', lvl).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute(key) === tab.getAttribute(key)); });
        if (key === 'data-door') { S.replaceDoor = tab.getAttribute('data-door'); initPhoneReplace(); }

        var strip = tab.parentNode, sr = strip.getBoundingClientRect(), tr = tab.getBoundingClientRect();
        strip.scrollTo({ left: strip.scrollLeft + (tr.left - sr.left) - (sr.width - tr.width) / 2, behavior: 'smooth' });
        return;
      }
      var x = t.closest('.xlink[data-open]');
      if (x) { goLevel(x.getAttribute('data-open')); var l2 = $('[data-lvl="' + x.getAttribute('data-open') + '"] .dr__tab[data-lens="size"]', dr); if (l2) l2.click(); }
    });
    dr.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var on = $('.dr__lvl.is-on:not(.dr__root)', dr);
        if (on) goLevel('root'); else closeDrawer();
        return;
      }
      if (e.key === 'Tab' && S.drawer) {
        var fs = $$('a[href], button:not([disabled]), input', dr).filter(function (el) {
          return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('.dr__lvl:not(.is-on)') && !el.closest('.dr__root.is-behind');
        });
        if (!fs.length) return;
        var first = fs[0], last = fs[fs.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }
  function initPhoneReplace() {
    var lvl = $('#ccn-drawer [data-lvl="replace"]');
    if (!lvl) return;
    if (!phonePart) phonePart = makePartLookup($('[data-partq]', lvl));
    if (!phoneFinder) loadFinder().then(function () { if (!phoneFinder) phoneFinder = makeFinder($('[data-finder]', lvl)); });
  }
  function phoneDoor(door) {
    var tab = $('#ccn-drawer [data-lvl="replace"] .dr__tab[data-door="' + door + '"]');
    if (tab) tab.click();
  }
  function goLevel(id) {
    var dr = $('#ccn-drawer');
    var root = $('.dr__root', dr), next = $('[data-lvl="' + id + '"]', dr);
    if (!next) return;
    $$('.dr__lvl', dr).forEach(function (l) { if (l !== next && l !== root) l.classList.remove('is-on'); });
    if (id === 'root') { root.classList.remove('is-behind'); root.classList.add('is-on'); var f = $('.dr__row', root); if (f) f.focus({ preventScroll: true }); return; }
    root.classList.add('is-behind');
    next.classList.add('is-on');
    next.scrollTop = 0;
    if (id === 'replace') initPhoneReplace();
    setTimeout(function () { var b = $('.dr__back', next); if (b) b.focus({ preventScroll: true }); }, 30);
  }

  function syncCall(scope) {

    var mp = $('.mast__phone'), dr = scope || $('#ccn-drawer');
    if (!mp || !dr) return;
    var href = mp.getAttribute('href'), num = $('b', mp), tracked = num ? num.textContent.trim() : '';
    var plain = (D.nav && D.nav.header && D.nav.header.phone) || '';
    $$('a[href^="tel:"]', dr).forEach(function (a) {
      if (href) a.setAttribute('href', href);
      if (!tracked || !plain || tracked === plain) return;
      var w = document.createTreeWalker(a, NodeFilter.SHOW_TEXT), t;
      while ((t = w.nextNode())) if (t.nodeValue.indexOf(plain) >= 0) t.nodeValue = t.nodeValue.split(plain).join(tracked);
    });
  }
  function openDrawer(level, quiet) {
    var dr = $('#ccn-drawer');
    renderDrawer();
    syncCall();
    dr.hidden = false;
    $('#ccn-scrim').hidden = false;
    S.drawer = true;
    $('#menu-btn').setAttribute('aria-expanded', 'true');
    document.body.classList.add('ccn-no-scroll');
    requestAnimationFrame(function () { requestAnimationFrame(function () { dr.classList.add('is-open'); }); });
    if (level) goLevel(level);
    else if (!quiet && !FRAMED) setTimeout(function () { var c = $('.dr__close', dr); if (c) c.focus({ preventScroll: true }); }, 30);
  }
  function closeDrawer() {
    var dr = $('#ccn-drawer');
    dr.classList.remove('is-open');
    S.drawer = false;
    $('#menu-btn').setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ccn-no-scroll');
    setTimeout(function () { if (!S.drawer) { dr.hidden = true; $('#ccn-scrim').hidden = true; goLevel('root'); } }, 240);
  }

  function fmtDate(iso, year) {
    var m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return iso;
    var mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][+m[2] - 1];
    return mon + ' ' + (+m[3]) + (year ? ', ' + m[1] : '');
  }
  function bindDock() {
    var dock = $('#dock');
    if (!dock || FRAMED || isPhone()) return;
    dock.hidden = false;
    var nav = D.nav, sw = nav.salesWindow;
    $('#dock-pop').innerHTML = '<p class="dock__pop-h">Where the numbers come from</p>' +
      '<p><b>Counts.</b> ' + esc(nav.countsSource) + ' As of ' + esc(fmtDate(nav.countsAsOf, true)) + '.</p>' +
      '<p><b>Most ordered.</b> ' + fmt(sw.orders) + ' Shopify orders, ' + esc(fmtDate(sw.from)) + ' to ' + esc(fmtDate(sw.to, true)) + ', cancelled orders left out. In a lens, one product per tile, most ordered tile first.</p>' +
      '<p><b>Highest sales.</b> Revenue from the same orders, counting only products ordered at least ' + fmt(nav.revenueMinOrders || 1) + ' times, so one bulk order is not a top seller.</p>' +
      '<p><b>Current site.</b> Screenshots of castercentral.com taken ' + esc($('#dock-today').textContent.replace(/^.*captured\s*/, '')) + '.</p>' +
      '<p>Links open the live store.</p>';
    dock.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      if (t.hasAttribute('data-view')) setView(t.getAttribute('data-view'));
      else if (t.hasAttribute('data-mode')) setMode(t.getAttribute('data-mode'));
      else if (t.id === 'dock-info') {
        var pop = $('#dock-pop'), open = pop.hidden;
        pop.hidden = !open;
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else if (t.hasAttribute('data-step') && window.CCTour) window.CCTour.run(+t.getAttribute('data-step'));
      else if (t.getAttribute('data-tour') && window.CCTour) window.CCTour.step(t.getAttribute('data-tour') === 'next' ? 1 : -1);
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'h' || e.key === 'H') && !e.metaKey && !e.ctrlKey && !e.altKey) {
        var a = document.activeElement;
        if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable)) return;
        dock.classList.toggle('is-hidden');
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#dock')) { var pop = $('#dock-pop'); if (!pop.hidden) { pop.hidden = true; $('#dock-info').setAttribute('aria-expanded', 'false'); } }
    });
  }
  function pressed(sel, attr, val) {
    $$(sel).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute(attr) === val ? 'true' : 'false'); });
  }

  var frameReady = null;
  function ensureFrame() {
    var f = $('#phone-frame');
    if (!frameReady) {
      frameReady = new Promise(function (res) {
        f.addEventListener('load', function () { res(f); }, { once: true });
      });
      f.removeAttribute('loading');
      f.src = location.pathname + '?phone=1';
    }
    return frameReady;
  }
  function frameAPI() {
    return ensureFrame().then(function (f) {
      var w = f.contentWindow;
      return (w.CCNav ? w.CCNav.ready : new Promise(function (r) { setTimeout(r, 300); })).then(function () { return w.CCNav; });
    });
  }

  var DOCK_H = 72;
  function scaleDevice() {
    var dev = $('#device');
    if (!dev) return;
    var cap = $('#phone-cap'), capH = cap && !cap.hidden ? 26 : 0;
    var room = window.innerHeight - DOCK_H - 24 - capH;
    var s = Math.min(1, room / 868, (window.innerWidth - 40) / 414);
    var top = Math.max(12, (room - 868 * s) / 2 + 12);
    dev.style.transform = 'translate(-50%, 0) scale(' + s.toFixed(3) + ')';
    dev.style.top = top.toFixed(1) + 'px';
    if (cap) cap.style.top = (top + 868 * s + 10).toFixed(1) + 'px';
  }
  function syncPhoneToday() {
    var img = $('#phone-today'), frame = $('#phone-frame'), cap = $('#phone-cap');
    var T = todayData();
    var on = S.view === 'phone' && S.mode === 'today';
    img.hidden = !on;
    frame.style.visibility = on ? 'hidden' : '';
    cap.hidden = !on;
    if (on) {
      if (!img.getAttribute('src')) img.src = T.phone[0];
      cap.textContent = 'Current site, menu open. Click the phone to open Casters.';
    }
    scaleDevice();
  }
  function setView(v) {
    S.view = v;
    pressed('#dock [data-view]', 'data-view', v);
    var stage = $('#phone-stage');
    if (v === 'phone') {
      closePanels(); closeSearch(); closeHelp();
      stage.hidden = false;
      document.body.classList.add('is-staged');
      ensureFrame();
      scaleDevice();
    } else {
      stage.hidden = true;
      document.body.classList.remove('is-staged');
    }
    syncPhoneToday();
  }

  var T_ = null;
  function todayData() { if (!T_) T_ = JSON.parse($('#today-data').textContent); return T_; }
  var todayBuilt = false;
  function buildToday() {
    if (todayBuilt) return;
    todayBuilt = true;
    var T = todayData(), box = $('#today');
    box.innerHTML = '<div class="today__frame"><img class="today__closed" src="' + esc(T.closed) + '" width="' + T.w + '" height="' + T.h + '" alt="castercentral.com header today">' +
      '<img class="today__panel" alt="castercentral.com menu open today" hidden></div>';
    var frame = $('.today__frame', box), panel = $('.today__panel', box);
    var cur = null, curImg = null, hideT = 0;
    T.items.forEach(function (it) { if (it.img) new Image().src = it.img; (it.states || []).forEach(function (s) { new Image().src = s.img; }); });
    function show(it, img) {
      clearTimeout(hideT);
      cur = it;
      if (curImg !== img) { panel.src = img; curImg = img; }
      panel.hidden = false;
    }
    function hide() { cur = null; curImg = null; panel.hidden = true; frame.style.cursor = ''; }
    frame.addEventListener('mousemove', function (e) {
      var r = frame.getBoundingClientRect(), k = T.w / r.width;
      var X = (e.clientX - r.left) * k, Y = (e.clientY - r.top) * k;
      if (Y >= T.barTop && Y <= T.barTop + T.barH) {
        var hit = null;
        T.items.forEach(function (it) { if (X >= it.x && X <= it.x + it.w) hit = it; });
        frame.style.cursor = hit ? 'pointer' : '';
        if (hit && hit.img) { show(hit, cur === hit ? curImg : hit.img); return; }
        if (hit) { hide(); return; }
      }
      if (cur && X >= cur.panelX && X <= cur.panelX + cur.panelW && Y >= cur.panelTop && Y <= cur.panelBottom) {
        clearTimeout(hideT);
        if (cur.rail && X >= cur.rail.x0 && X <= cur.rail.x1 && Y >= cur.rail.y0 && Y <= cur.rail.y1) {
          var row = Math.floor((Y - cur.rail.y0) / ((cur.rail.y1 - cur.rail.y0) / cur.rail.rows));
          if (row === 0) show(cur, cur.img);
          (cur.states || []).forEach(function (s) { if (s.row === row) show(cur, s.img); });
        }
        return;
      }
      if (cur) { clearTimeout(hideT); hideT = setTimeout(hide, 160); }
    });
    frame.addEventListener('mouseleave', function () { clearTimeout(hideT); hideT = setTimeout(hide, 160); });
  }
  function setMode(m) {
    S.mode = m;
    pressed('#dock [data-mode]', 'data-mode', m);
    var top = $('#site-top'), today = $('#today'), lab = $('#dock-today');
    if (m === 'today') {
      closePanels(); closeSearch(); closeHelp();
      buildToday();
      top.hidden = true;
      today.hidden = false;
      lab.hidden = false;
      ROOT.classList.add('is-today');
    } else {
      top.hidden = false;
      today.hidden = true;
      lab.hidden = true;
      ROOT.classList.remove('is-today');
      fitBar();
    }
    syncPhoneToday();
  }

  function bindHero() {
    var sel = $('#hcard-dia'), go = $('#hcard-go');
    if (!sel || !go) return;
    sel.addEventListener('change', function () {
      var b = sel.getAttribute('data-base');
      go.href = sel.value ? b + '?' + sel.getAttribute('data-param') + '=' + encodeURIComponent(sel.value) : b;
    });
  }

  function onResize() {
    var phone = FRAMED || window.matchMedia('(max-width: 1023px)').matches;  
    ROOT.classList.toggle('ccn-phone', phone);
    ROOT.classList.toggle('ccn-desk', !phone);
    if (phone) { closePanels(); } else { if (S.drawer) closeDrawer(); fitBar(); if (S.open) layoutPanel($('#panel-' + S.open)); }
    scaleDevice();
  }
  function boot() {
    if (!$('#bar-list')) return;
    bindHelp();
    bindHero();
    $('#menu-btn').addEventListener('click', function () { if (S.drawer) closeDrawer(); else openDrawer(); });
    $('#search-icon').addEventListener('click', function () { openDrawer(); setTimeout(function () { var d = $('#dq'); if (d) d.focus(); }, 260); });
    $('#ccn-scrim').addEventListener('click', closeDrawer);
    document.querySelectorAll('.ccn-body-mount').forEach(function (m) { document.body.appendChild(m); });
    var pt = $('#phone-today');
    if (pt) pt.addEventListener('click', function () {
      var T = todayData(), img = $('#phone-today');
      var i = T.phone.indexOf(img.getAttribute('src'));
      img.src = T.phone[(i + 1) % T.phone.length];
      $('#phone-cap').textContent = img.getAttribute('src') === T.phone[0] ? 'Current site, menu open. Click the phone to open Casters.' : 'Current site, Casters open. Click to go back.';
    });
    getJSON('nav-data.json').then(function (nav) {
      D.nav = nav;
      renderBar();
      renderPanels();
      bindPanels();
      initReplace();
      deskSearch = makeSearch($('#q'), $('#search-pop'));
      bindDock();
      fitBar();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitBar);
      window.addEventListener('resize', onResize);
      readyResolve(api);
    }).catch(function (e) {
      console.error(e);
    });
  }

  var api = {
    ready: ready,
    state: S,
    data: function () { return D.nav; },
    openPanel: function (id, o) { o = o || {}; if (!o.by) o.by = 'tour'; openPanel(id, o); },
    closePanels: closePanels,
    setLens: setLens,
    openReplace: openReplace,
    finderPick: function (field, label) {
      var f = isPhone() ? phoneFinder : deskFinder;
      return f ? f.pick(field, label) : false;
    },
    finderReset: function () { var f = isPhone() ? phoneFinder : deskFinder; if (f) f.reset(); },
    finderTotal: function () { var f = isPhone() ? phoneFinder : deskFinder; return f ? f.total() : null; },
    finderReady: function () { return loadFinder().then(function () { return sleep(30); }); },
    typeSearch: function (text, delay) { closePanels(); return deskSearch.type(text, delay); },
    clearSearch: function () { if (deskSearch) { deskSearch.input.value = ''; deskSearch.hide(); deskSearch.input.blur(); } },
    loadSearch: loadSearch,
    runSearch: function (q) { return loadSearch().then(function () { return runSearch(q); }); },
    setView: setView,
    setMode: setMode,
    openDrawer: function (level) { return openDrawer(level, true); },
    closeDrawer: closeDrawer,
    goLevel: goLevel,
    frameAPI: frameAPI,
    isPhone: isPhone
  };
  window.CCNav = api;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
